<template>
  <div>
    <div class="congtent">
      <div class="congtentheader">
        <div class="congtentheadertext">{{ swiperList.text }}</div>
      </div>
      <!-- 个人默认回显 -->
      <div class="congtentmiddle" v-if="swiperList.userType == '1' &&
        swiperList.text != '新生儿出生证明登记' &&
        swiperList.text != '个人高校学位证明办理打印' &&
        swiperList.text != '高校学位证书查询' &&
        swiperList.text != '婚姻关系证明' &&
        swiperList.text != '个人婚姻关系证明办理打印' &&
        swiperList.text != '火化证明查询' &&
        swiperList.text != '死亡医学证明信息查询' &&
        swiperList.text != '事故基本信息' &&
        swiperList.text != '国家出生医学证明办理查询' &&
        swiperList.text != '国家出生医学证明办理打印'
        &&
        swiperList.text != '婚姻登记预约'
        ">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="name">
            <el-input v-model="ruleForm.idcrad" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                查询
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 码上共享 -->
      <div class="congtentmiddle" v-if="swiperList.text == '码上共享'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="需求类型" prop="requirementTypeListseq" :rules="{
            required: true,
            message: '请选择需求类型',
            trigger: 'change',
          }">
            <el-select v-model="ruleForm.requirementTypeListseq" placeholder="请选择需求类型" class="congtentmiddle_toptextinput"
              @change="chagerequirementTypeList($event)" clearable>
              <el-option v-for="item in requirementTypeList" :key="item.seq" :label="item.name" :value="item.seq">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="需求类别" prop="requirementStatusListseq" :rules="{
            required: true,
            message: '请选择需求类别',
            trigger: 'change',
          }">
            <el-select v-model="ruleForm.requirementStatusListseq" placeholder="请选择需求类别"
              class="congtentmiddle_toptextinput" clearable>
              <el-option v-for="item in requirementStatusList" :key="item.seq" :label="item.name" :value="item.seq">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用场景及应用事项" prop="desc" :rules="{
            required: true,
            message: '请输入应用场景及应用事项',
            trigger: 'blur',
          }">
            <el-input type="textarea" v-model="ruleForm.desc" class="congtentmiddle_toptextinput"
              placeholder="请输入应用场景及应用事项(50字)" maxlength="50" style="height: auto"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goecked('4')">查询</div>
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 码上维权 -->
      <div class="congtentmiddle" v-if="swiperList.text == '码上维权'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="企业名称" prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" placeholder="请输入企业名称"
              disabled></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="phonename">
            <el-input v-model="ruleForm.username" class="congtentmiddle_toptextinput" placeholder="请输入联系人"
              disabled></el-input>
          </el-form-item>
          <el-form-item label="联系人手机号" prop="phone">
            <el-input v-model="ruleForm.phone" class="congtentmiddle_toptextinput" placeholder="请输入联系人手机号"
              disabled></el-input>
          </el-form-item>
          <el-form-item label="维权内容" prop="desc" :rules="{
            required: true,
            message: '请输入维权内容',
            trigger: 'blur',
          }">
            <el-input type="textarea" v-model="ruleForm.desc" class="congtentmiddle_toptextinput"
              placeholder="请输入维权内容(最多50字)" style="height: auto"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goecked('2')">查询</div>
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 码上创业 -->
      <div class="congtentmiddle" v-if="swiperList.text == '码上创业'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="企业名称" prop="enterpriseName" :rules="{
            required: true,
            message: '请输入企业名称',
            trigger: 'blur',
          }">
            <el-input v-model="ruleForm.enterpriseName" class="congtentmiddle_toptextinput"
              placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="phonename" :rules="[
            { required: true, message: '请输入联系人', trigger: 'blur' },
            {
              pattern: /^[\u4e00-\u9fa5]{0,}$/,
              message: '联系人只能为中文',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.phonename" class="congtentmiddle_toptextinput" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系人手机号" prop="phonenumber" :rules="[
            {
              required: true,
              message: '请输入联系人手机号',
              trigger: 'blur',
            },
            {
              pattern:
                /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/,
              message: '请输入正确的手机号',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.phonenumber" class="congtentmiddle_toptextinput" placeholder="请输入联系人手机号"
              maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="服务类型" prop="requirementTypeListseq" :rules="{
            required: true,
            message: '请选择服务类型',
            trigger: 'change',
          }">
            <el-select v-model="ruleForm.requirementTypeListseq" placeholder="请选择服务类型" class="congtentmiddle_toptextinput"
              clearable>
              <el-option v-for="item in requirementTypeList" :key="item.seq" :label="item.name" :value="item.seq">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="说明" prop="desc" :rules="{ required: true, message: '请输入说明', trigger: 'blur' }">
            <el-input type="textarea" v-model="ruleForm.desc" class="congtentmiddle_toptextinput"
              placeholder="请输入说明(最多50字)" maxlength="50" style="height: auto"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goecked('3')">查询</div>
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 我向政务服务说句话 -->
      <div class="congtentmiddle" v-if="swiperList.text == '我向政务服务说句话'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="您的姓名" prop="name">
            <el-input v-model="ruleForm.username" class="congtentmiddle_toptextinput" placeholder="请输入您的姓名"
              disabled></el-input>
          </el-form-item>
          <el-form-item label="您的手机号" prop="phonenumber" disabled>
            <el-input v-model="ruleForm.phone" class="congtentmiddle_toptextinput" placeholder="请输入您的手机号" maxlength="11"
              disabled></el-input>
          </el-form-item>
          <el-form-item label="窗口信息" prop="wind" :rules="{
            required: true,
            message: '请输入窗口信息',
            trigger: 'blur',
          }">
            <el-input type="textarea" v-model="ruleForm.wind" class="congtentmiddle_toptextinput"
              placeholder="请输入窗口信息(最多20字)" maxlength="20" style="height: auto"></el-input>
          </el-form-item>
          <el-form-item label="问题建议" prop="desc" :rules="{
            required: true,
            message: '请输入问题建议',
            trigger: 'blur',
          }">
            <el-input type="textarea" v-model="ruleForm.desc" class="congtentmiddle_toptextinput"
              placeholder="请输入问题建议(最多500字)" maxlength="500" style="height: auto"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goeck('ruleForm')">
                查询
              </div>
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 码上融资 -->
      <div class="congtentmiddle" v-if="swiperList.text == '码上融资'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="企业名称" prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="phonenumber" disabled>
            <el-input v-model="ruleForm.username" class="congtentmiddle_toptextinput" maxlength="11" disabled></el-input>
          </el-form-item>
          <el-form-item label="联系人手机号码" prop="phonenumber" disabled>
            <el-input v-model="ruleForm.phone" class="congtentmiddle_toptextinput" maxlength="11" disabled></el-input>
          </el-form-item>
          <el-form-item label="所属区县" prop="aralistSeq" :rules="{
            required: true,
            message: '请选择所属区县',
            trigger: 'change',
          }">
            <el-select v-model="ruleForm.aralistSeq" placeholder="请选择所属区县" class="congtentmiddle_toptextinput" clearable>
              <el-option v-for="item in aralist" :key="item.areaCode" :label="item.dictName" :value="item.areaCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业地址" prop="enterpriseAddress" :rules="{
            required: true,
            message: '请输入企业地址',
            trigger: 'blur',
          }">
            <el-input v-model="ruleForm.enterpriseAddress" class="congtentmiddle_toptextinput" placeholder="请输入企业地址"
              maxlength="20" style="height: auto"></el-input>
          </el-form-item>
          <el-form-item label="企业成立时间" prop="enterpriseCreate" :rules="{
            required: true,
            message: '请选择企业成立时间',
            trigger: 'change',
          }">
            <el-date-picker v-model="ruleForm.enterpriseCreate" type="date" placeholder="请选择企业成立时间"
              format="yyyy 年 MM 月 dd 日" class="congtentmiddle_toptextinput" style="width: 492px">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="首贷/继贷" prop="optionSeq" :rules="{
            required: true,
            message: '请选择首贷/继贷',
            trigger: 'change',
          }">
            <el-select v-model="ruleForm.optionSeq" placeholder="请选择首贷/继贷" class="congtentmiddle_toptextinput" clearable>
              <el-option v-for="item in options" :key="item.loanType" :label="item.name" :value="item.loanType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="贷款需求额度" prop="money" :rules="{
            required: true,
            message: '请输入贷款需求额度',
            trigger: 'blur',
          }">
            <el-input v-model="ruleForm.money" class="congtentmiddle_toptextinput" placeholder="请输入贷款需求额度（万元）"
              maxlength="20" style="height: auto"></el-input>
          </el-form-item>
          <el-form-item label="是否有抵押物" prop="collateral" :rules="{
            required: true,
            message: '请输入是否有抵押物',
            trigger: 'blur',
          }">
            <el-input v-model="ruleForm.collateral" class="congtentmiddle_toptextinput"
              placeholder="(若没有请填“无”;若有需写明具体抵押物，如房屋厂房设备等)" maxlength="20" style="height: auto"></el-input>
          </el-form-item>
          <el-form-item label="目标银行" prop="banklistseq" :rules="{
            required: true,
            message: '请选择目标银行',
            trigger: 'change',
          }">
            <el-select v-model="ruleForm.banklistseq" placeholder="请选择目标银行" class="congtentmiddle_toptextinput" clearable>
              <el-option v-for="item in banklist" :key="item.SEQ" :label="item.DEPT_NAME" :value="item.SEQ">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goecked('1')">查询</div>
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 新生儿出生证明登记 -->
      <div class="congtentmiddle" v-if="swiperList.text == '新生儿出生证明登记' ||
        swiperList.text == '国家出生医学证明办理查询' ||
        swiperList.text == '国家出生医学证明办理打印'
        ">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="出生证号" prop="birthCode" :rules="[
            { required: true, message: '请输入出生证号', trigger: 'blur' },
          ]">
            <el-input v-model="ruleForm.birthCode" class="congtentmiddle_toptextinput" placeholder="请输入出生证号"
              maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="母亲姓名" prop="momName" :rules="[
            { required: true, message: '请输入母亲姓名', trigger: 'blur' },
            {
              pattern: /^[\u4e00-\u9fa5]{0,}$/,
              message: '联系人只能为中文',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.momName" class="congtentmiddle_toptextinput" placeholder="请输入母亲姓名"
              maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="母亲身份证号" prop="momIdCode" :rules="[
            {
              required: true,
              message: '请输入母亲身份证号',
              trigger: 'blur',
            },
            {
              pattern:
                /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: '证件号码格式有误！',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.momIdCode" class="congtentmiddle_toptextinput" placeholder="请输入母亲身份证号"></el-input>
          </el-form-item>

          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 个人高校学位证明办理打印和高校学位信息查询-->
      <div class="congtentmiddle" v-if="swiperList.text == '个人高校学位证明办理打印' ||
        swiperList.text == '高校学位证书查询'
        ">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="证书号码" prop="certificateNumber" :rules="[
            { required: true, message: '请输入证书号码', trigger: 'blur' },
            {
              pattern: /^[0-9]*$/,
              message: '证书号码不能含有中文,特殊符号',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.certificateNumber" class="congtentmiddle_toptextinput" placeholder="请输入证书号码"
              maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>

          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 婚姻登记预约 -->
      <div class="congtentmiddle" v-if="swiperList.text == '婚姻登记预约'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idcrad">
            <el-input v-model="ruleForm.idcrad" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="ruleForm.phone" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="预约时间" prop="value1" :rules="{
            required: true,
            message: '请选择预约时间',
            trigger: 'change',
          }">
            <el-date-picker v-model="ruleForm.value1" type="date" placeholder="请选择预约时间"
              class="congtentmiddle_toptextinput" value-format="yyyy-MM-dd" style="width: 492px">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="预约时间段" prop="sjd" :rules="{
            required: true,
            message: '请选择预约时间段',
            trigger: 'change',
          }">
            <el-select v-model="ruleForm.sjd" placeholder="请选择预约时间段" class="congtentmiddle_toptextinput" clearable>
              <el-option v-for="item in sjdoptions" :key="item.val" :label="item.name" :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                预约
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 婚姻关系证明 和个人婚姻关系证明办理打印-->
      <div class="congtentmiddle" v-if="swiperList.text == '婚姻关系证明' ||
        swiperList.text == '个人婚姻关系证明办理打印'
        ">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="男方姓名" prop="nName" :rules="[
            { required: true, message: '请输入男方姓名', trigger: 'blur' },
            {
              pattern: /^[\u4e00-\u9fa5]{0,}$/,
              message: '男方姓名只能为中文',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.nName" class="congtentmiddle_toptextinput" placeholder="请输入男方姓名"
              maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="男方身份证号" prop="nIdcard" :rules="[
            {
              required: true,
              message: '请输入男方身份证号',
              trigger: 'blur',
            },
            {
              pattern:
                /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: '证件号码格式有误！',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.nIdcard" class="congtentmiddle_toptextinput" placeholder="请输入男方身份证号"
              maxlength="18"></el-input>
          </el-form-item>
          <el-form-item label="女方姓名" prop="gName" :rules="[
            { required: true, message: '请输入女方姓名', trigger: 'blur' },
            {
              pattern: /^[\u4e00-\u9fa5]{0,}$/,
              message: '女方姓名只能为中文',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.gName" class="congtentmiddle_toptextinput" placeholder="请输入女方姓名"
              maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="女方身份证号" prop="gIdcard" :rules="[
            {
              required: true,
              message: '请输入男方身份证号',
              trigger: 'blur',
            },
            {
              pattern:
                /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: '证件号码格式有误！',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.gIdcard" class="congtentmiddle_toptextinput" placeholder="请输入女方身份证号"
              maxlength="18"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>

          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!--火化证明查询和死亡医学证明信息查询-->
      <div class="congtentmiddle" v-if="swiperList.text == '火化证明查询' ||
        swiperList.text == '死亡医学证明信息查询'
        ">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="nameValue" :rules="[
            { required: true, message: '请输入姓名', trigger: 'blur' },
            {
              pattern: /^[\u4e00-\u9fa5]{0,}$/,
              message: '姓名只能为中文',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.nameValue" class="congtentmiddle_toptextinput" placeholder="请输入姓名"
              maxlength="16"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCardValue" :rules="[
            { required: true, message: '请输入身份证号', trigger: 'blur' },
            {
              pattern:
                /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: '证件号码格式有误！',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.idCardValue" class="congtentmiddle_toptextinput" placeholder="请输入身份证号"
              maxlength="18"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>

          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 事故基本信息 -->
      <div class="congtentmiddle" v-if="swiperList.text == '事故基本信息'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="查询时间" prop="value" :rules="[
            {
              type: 'string',
              required: true,
              message: '请选择日期',
              trigger: 'change',
            },
          ]">
            <el-date-picker v-model="ruleForm.value" type="month" placeholder="请选择日期" value-format="yyyy-MM"
              style="width: 340px; margin-left: 12px">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>

          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')" style="margin-left: 20px">
                提交
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')" style="margin-left: 20px">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 股权出质变更登记信息 -->
      <div class="congtentmiddle" v-if="swiperList.text == '股权出质变更登记信息'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="机构标识" prop="unitValue" :rules="[
            { required: true, message: '请输入机构标识', trigger: 'blur' },
            {
              pattern: /^[0-9]*$/,
              message: '机构标识不能含有中文,特殊符号',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.unitValue" class="congtentmiddle_toptextinput" maxlength="20"
              placeholder="请输入机构标识"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                查询
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 建筑市场企业信息 -->
      <div class="congtentmiddle" v-if="swiperList.text == '建筑市场企业信息'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="查询时间" prop="value" :rules="[
            {
              type: 'string',
              required: true,
              message: '请选择日期',
              trigger: 'change',
            },
          ]">
            <el-date-picker v-model="ruleForm.value" type="month" placeholder="请选择日期" value-format="yyyy-MM"
              style="width: 340px; margin-left: 12px">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="name">
            <el-input v-model="ruleForm.idcrad" class="congtentmiddle_toptextinput" disabled
              style="width: 340px; margin-left: 12px"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                查询
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 建筑市场人员信息 -->
      <div class="congtentmiddle" v-if="swiperList.text == '建筑市场人员信息' ||
        swiperList.text == '建筑市场人员信息证明办理打印'
        ">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="查询时间" prop="value" :rules="[
            {
              type: 'string',
              required: true,
              message: '请选择日期',
              trigger: 'change',
            },
          ]">
            <el-date-picker v-model="ruleForm.value" type="month" placeholder="请选择日期" value-format="yyyy-MM"
              style="width: 340px; margin-left: 12px">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="法人身份证号" prop="name">
            <el-input v-model="ruleForm.paperCode" class="congtentmiddle_toptextinput" disabled
              style="width: 340px; margin-left: 12px"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                查询
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 异常名录主体信息 -->
      <div class="congtentmiddle" v-if="swiperList.text == '异常名录主体信息'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="企业标识" prop="marprId" :rules="[
            { required: true, message: '请输入企业标识', trigger: 'blur' },
            {
              pattern: /^[0-9]*$/,
              message: '企业标识不能含有中文,特殊符号',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="ruleForm.marprId" class="congtentmiddle_toptextinput"
              style="width: 340px; margin-left: 12px" placeholder="请输入企业标识"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                查询
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 法人默认回显 -->
      <div class="congtentmiddle" v-if="swiperList.userType == '2' &&
        swiperList.text != '股权出质变更登记信息' &&
        swiperList.text != '建筑市场企业信息' &&
        swiperList.text != '建筑市场人员信息' &&
        swiperList.text != '建筑市场人员信息证明办理打印' &&
        swiperList.text != '异常名录主体信息'
        ">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <el-form-item label="企业名称" prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="name">
            <el-input v-model="ruleForm.idcrad" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                查询
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 结果页面 -->
      <div class="congtentresult" v-if="tableValshow == true" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="contentresulttextheader">
          <div class="contentresulttext">查询结果</div>
          <div class="contentresulttextdown" v-if="swiperList.print == true && imgData != ''" @click="downloadIamge">
            下载
          </div>
          <div class="contentresulttextdown" v-if="(swiperList.print == true &&
              swiperList.text == '公积金缴存证明打印') ||
            swiperList.text == '社保缴费证明打印' ||
            swiperList.text == '个人失业登记信息打印' ||
            swiperList.text == '个人高校学位证明办理打印' ||
            swiperList.text == '婚姻登记证明办理打印' ||
            swiperList.text == '个人婚姻关系证明办理打印' ||
            swiperList.text == '企业法人公共信用评价结果打印' ||
            swiperList.text == '建筑市场人员信息证明办理打印' ||
            swiperList.text == '事业单位信息证明办理打印' ||
            swiperList.text == '企业投资人证明办理打印' ||
            swiperList.text == '年报信息查询打印' ||
            swiperList.text == '法人黑名单证明办理打印' ||
            swiperList.text == '个人社保参保信息证明办理打印' ||
            swiperList.text == '国家出生医学证明办理打印' ||
            swiperList.text == '企业黑名单证明办理打印'
            " @click="saveImg">
            下载
          </div>
        </div>
        <div v-if="tableVal.length != 0" class="congtentHaveresult">
          <div v-for="(item, index) in tableVal" :key="index" style="
              margin-top: 20px;
              display: flex;
              flex-wrap: wrap;
              flex-direction: row;
            ">
            <div v-for="(items, index) in item" :key="index" style="display: flex; flex-wrap: wrap; flex-direction: row">
              <div class="congtentHaveresulttopleft">
                <div class="congtentHaveresulttoplefttxt">
                  {{ items.title }}
                </div>
                <div class="congtentHaveresulttopleftnumber">
                  {{
                    items.body == ""
                    ? "-"
                    : items.title == "负责人" ||
                      items.title == "经费来源" ||
                      items.title == "男方姓名" ||
                      items.title == "女方姓名" ||
                      items.title == "职工姓名" ||
                      items.title == "投资人名称" ||
                      items.title == "姓名" ||
                      items.title == "父亲姓名" ||
                      items.title == "母亲姓名" ||
                      items.title == "孩子姓名"
                      ? desensitizeChineseName(items.body)
                      : items.title == "身份证号码" ||
                        items.title == "居民身份证号码" ||
                        items.title == "女方身份证号" ||
                        items.title == "男方身份证号" ||
                        items.title == "身份证号" ||
                        items.title == "父亲身份证号" ||
                        items.title == "证件号码" ||
                        items.title == "母亲身份证号" ||
                        items.title == "孩子身份证号" ||
                        items.title == "公民身份证号"
                        ? desensitizeIDNumber(items.body)
                        : items.title == "处罚决定书签发日期" ||
                          items.title == "受理日期" ||
                          items.title == "年报创建时间" ||
                          items.title == "操作日期" ||
                          items.title == "加入日期" ||
                          items.title == "有效日期截止到" ||
                          items.title == "交换时间戳" ||
                          items.title == "加入时间" ||
                          items.title == "成立日期" ||
                          items.title == "经营期限止" ||
                          items.title == "经营期限起" ||
                          items.title == "创建日期" ||
                          items.title == "（变更）核准日期" ||
                          items.title == "设立日期" ||
                          items.title == "时间戳" ||
                          items.title == "列入日期" ||
                          items.title == "移出日期" ||
                          items.title == "创建时间"
                          ? timestampToTime(items.body)
                          : items.body
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tableVal.length == 0 && imgData == ''" class="congtentresultarr">
          <div class="contentresulttextline"></div>
          <img src="../assets/noreslute.png" class="congtentresultimg" />
          <div class="congtentresultimgtext">暂无结果</div>
        </div>
        <div class="congtentresultimage" v-if="type != 2">
          <img :src="imgData" />
        </div>
        <div class="congtentresultimage" v-if="type == 2">
          <img :src="imgData" style="width: 1140px; margin-top: 30px" />
        </div>
      </div>
      <!-- 我向服务说句话结果页面   -->

      <div class="congtentresult" v-if="tableList == true" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading="loading">
        <div class="contentresulttextheader">
          <div class="contentresulttext">查询结果</div>
        </div>
        <div v-if="tableListadd.length != 0" class="congtentHaveresult" ref="imgBox">
          <div v-for="(item, index) in tableListadd" :key="index" style="
              margin-top: 20px;
              display: flex;
              flex-wrap: wrap;
              flex-direction: row;
            ">
            <div v-for="(items, index) in item" :key="index">
              <div class="congtentHaveresulttopleft">
                <div class="congtentHaveresulttoplefttxt">
                  {{ items.title }}
                </div>
                <div class="congtentHaveresulttopleftnumber">
                  {{ items.body }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tableListadd.length == 0" class="congtentresultarr">
          <div class="contentresulttextline"></div>
          <img src="../assets/noreslute.png" class="congtentresultimg" />
          <div class="congtentresultimgtext">暂无结果</div>
        </div>
      </div>

      <!-- 公积金打印和个人参保打印 -->
      <div v-if="type" style="position: absolute; top: -99999px">
        <div class="mainCenterMains" ref="imgBox">
          <div class="MidSpaceTopTitles">
            <div style="height: 1px"></div>
            <div class="MidSpaceTopStyle">
              <div class="MidSpaceTopPic">
                <img class="h40" style="height: 35px" src="../assets/guohui.png" />
                <span style="font-size: 24px">大庆政务服务网</span>
              </div>
              <div>
                <span class="MidSpaceTopNum f18">查验流水号:</span>
                <span class="MidSpaceTopNum">{{ responseId }}</span>
              </div>
            </div>
            <div class="MidSpaceEr">
              <div class="MidSpaceName">{{ swiperList.text }}</div>
            </div>
            <div class="MidSpacePer1">
              <span>尊敬的</span>
              <span class="MidSpacePerName1">{{ loginInfo.username }}</span>
              <span class="MidSpacePerId1">{{ loginInfo.paperCode }}</span>
              <span class="MidSpacePerName1">:</span>
            </div>
            <div class="MidSpacePerInfo1">
              <span>您于</span>
              <span class="MidSpacePerData"> {{ timerNow }} </span>
              <span> 通过黑龙江省政务服务网</span>
              <span>查询</span>
              <span class="MidSpaceComName">{{ swiperList.text }}</span>
              <span>相关信息，查询结果如下 ：</span>
            </div>
            <div class="sTable">
              <div v-for="(item, index) in tableVal" :key="index"
                style="display: flex; flex-wrap: wrap; flex-direction: row">
                <div v-for="(items, index) in item" :key="index" style="
                    display: flex;
                    flex-wrap: wrap;
                    flex-direction: row;
                    margin: 0 auto;
                  ">
                  <div class="congtentHaveresulttoplefted">
                    <div class="congtentHaveresulttoplefttxted">
                      {{ items.title }}
                    </div>
                    <div class="congtentHaveresulttopleftnumbered">
                      {{
                        items.body == ""
                        ? "-"
                        : items.title == "负责人" ||
                          items.title == "经费来源" ||
                          items.title == "男方姓名" ||
                          items.title == "女方姓名" ||
                          items.title == "职工姓名" ||
                          items.title == "投资人名称" ||
                          items.title == "姓名" ||
                          items.title == "父亲姓名" ||
                          items.title == "母亲姓名" ||
                          items.title == "孩子姓名"
                          ? items.body
                          : items.title == "身份证号码" ||
                            items.title == "居民身份证号码" ||
                            items.title == "女方身份证号" ||
                            items.title == "男方身份证号" ||
                            items.title == "身份证号" ||
                            items.title == "父亲身份证号" ||
                            items.title == "证件号码" ||
                            items.title == "母亲身份证号" ||
                            items.title == "孩子身份证号" ||
                            items.title == "公民身份证号"
                            ? items.body
                            : items.title == "处罚决定书签发日期" ||
                              items.title == "受理日期" ||
                              items.title == "年报创建时间" ||
                              items.title == "操作日期" ||
                              items.title == "加入日期" ||
                              items.title == "有效日期截止到" ||
                              items.title == "交换时间戳" ||
                              items.title == "加入时间" ||
                              items.title == "成立日期" ||
                              items.title == "经营期限止" ||
                              items.title == "经营期限起" ||
                              items.title == "创建日期" ||
                              items.title == "（变更）核准日期" ||
                              items.title == "设立日期" ||
                              items.title == "时间戳" ||
                              items.title == "列入日期" ||
                              items.title == "移出日期" ||
                              items.title == "创建时间"
                              ? items.body
                              : items.body
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="MidSpaceBottom1">
              <span>我已核对以上信息，并承诺信息内容真实准确，如有虚假责任自负！</span>
            </div>
            <div class="MidSpaceBottom1">
              <span>本人签字：</span>
              <div class="Cross"></div>
            </div>
            <div class="MidSpaceBottomRight1">
              <img style="height: 120px; width: 120px; margin-top: -35px" src="../assets/yinzhang.png" />
              <div class="namesssss">大庆政务服务网</div>
              <div class="MidSpaceBottomRightDate1">
                {{ timerNow.split(" ")[0] }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 我要纠错 -->
      <div class="congtentfooterno" @click="gourl()">
        <img src="../assets/bottomicon.png" class="congtentfooternoimg" />
        <div class="congtentfooternotext">我要纠错</div>
      </div>
      <div class="congtentfooternotexttwo">
        本服务由大庆市营商环境建设监督局提供
      </div>
    </div>
  </div>
</template>

<script>
import appCollection from "@/common/appCollection.js";
import { GVerify } from "@/utils/jqGetCode.js";

import commonUtils from "@/utils/commonUtils.js";
import html2canvas from "html2canvas";
import { createsign, query, switchTicket, getAssessInfo } from "@/api/api";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    var checkinputcode = (rule, inputcode, callback) => {
      if (inputcode === "") {
        callback(new Error("验证码不能为空"));
      } else if (inputcode.length !== 4) {
        callback(new Error("验证码长度为4个字符!"));
      } else if (
        this.verifyCode.options.code.toLowerCase() !=
        this.ruleForm.inputcode.toLowerCase()
      ) {
        callback(new Error("验证码不正确!"));
      } else {
        callback();
      }
    };
    return {
      swiperListOrg: [
        {
          applicationId: "pc-jszzzctlyt",
          text: "大庆市驾驶证证照",
          userType: 1,
        },
        {
          applicationId: "pc-jszzzdypszaa",
          text: "大庆市驾驶证打印",
          userType: 1,
          print: true,
        },

        {
          applicationId: "pc-hzzzwuyxx",
          text: "大庆市护照查询",
          userType: 1,
        },
        {
          applicationId: "pc-hzzzdyeywnh",
          text: "大庆市护照打印",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-hkbzzgygex",
          text: "大庆市户口本查询",
          userType: 1,
        },
        {
          applicationId: "pc-hkbzzdyhjnwz",
          text: "大庆市户口本打印",
          userType: 1,
          print: true,
        },

        {
          applicationId: "pc-jzzzzxnpsi",
          text: "大庆市居住证查询",
          userType: 1,
        },
        {
          applicationId: "pc-jzzzzdyeqvkg",
          text: "大庆市居住证打印",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-sfzzzdruvz",
          text: "大庆市身份证查询",
          userType: 1,
        },
        {
          applicationId: "pc-sfzzzdyyrkqj",
          text: "大庆市身份证打印",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-jkzcxibejd",
          text: "大庆市从业人员健康检查合格证明",
          userType: 1,
        },
        {
          applicationId: "pcd-dqsgjjcxxvnto",
          text: "大庆市公积金查询",
          userType: 1,
        },
        {
          applicationId: "pc-dqsgjjdyctdpu",
          text: "公积金缴存证明打印",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-dqsrqjyxkzwrcqz",
          text: "大庆市燃气经营许可证",
          userType: 2,
        },
        {
          applicationId: "pc-dqsrqjyxkzdyejykj",
          text: "大庆市燃气经营许可证打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "pc-dqssydwfrzstbrda",
          text: "大庆市事业单位法人证书",
          userType: 2,
        },
        {
          applicationId: "pc-dqssydwfrzsdyrglwk",
          text: "大庆市事业单位法人证书打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "pc-dqskdywjyxkzmpbsg",
          text: "大庆市快递业务经营许可证",
          userType: 2,
        },
        {
          applicationId: "pc-dqskdywjyxkzdywhran",
          text: "大庆市快递业务经营许可证打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "pc-mscyenbli",
          text: "码上创业",
        },
        {
          applicationId: "pc-mswqmvuze",
          text: "码上维权",
        },
        {
          applicationId: "pc-msgxpnyoe",
          text: "码上共享",
        },
        {
          applicationId: "pc-wxzwfwsjhcqfce",
          text: "我向政务服务说句话",
        },
        {
          applicationId: "pc-msrzesrrz",
          text: "码上融资",
        },
        {
          applicationId: "pc-frhmdcxewlnc",
          text: "法人黑名单查询",
          userType: 2,
        },
        {
          applicationId: "pc-qyhmdxxgitwf",
          text: "企业黑名单信息",
          userType: 2,
        },
        {
          applicationId: "pc-qyhmdzmbldyvcnnu",
          text: "企业黑名单证明办理打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "pc-cbpzcxugmcr",
          text: "参保凭证查询",
          userType: 1,
        },
        {
          applicationId: "pc-sbjfzmdykopsr",
          text: "社保缴费证明打印",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-grsbcbxxzmbldylluvc",
          text: "个人社保参保信息证明办理打印",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-dqsgrsbcbxxgejpc",
          text: "大庆市个人社保参保信息",
          userType: 1,
        },
        {
          applicationId: "pc-grsydjxxcxcxiby",
          text: "个人失业登记信息查询",
          userType: 1,
        },
        {
          applicationId: "pc-grsydjxxcxcxiby",
          text: "新生儿出生证明登记",
          userType: 1,
        },
        {
          applicationId: "pc-gjcsyxzmblcxwnjxw",
          text: "国家出生医学证明办理查询",
          userType: 1,
        },
        {
          applicationId: "pc-gjcsyxzmbldykszzo",
          text: "国家出生医学证明办理打印",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-bdcdjxxcxghvrl",
          text: "不动产登记信息查询",
          userType: 1,
        },
        {
          applicationId: "pc-bdcdjxxyzdylwv",
          text: "不动产产权验真",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-dzyyzzxxcxoysen",
          text: "电子营业执照信息查询",
          userType: 2,
        },
        {
          applicationId: "pc-dzyyzzxxdyxxnkx",
          text: "电子营业执照信息打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "pc-gjjdkjdcxttyjk",
          text: "公积金贷款进度查询",
          userType: 1,
        },
        {
          applicationId: "pc-gjjhdjlcxxmvap",
          text: "公积金还贷记录查询",
          userType: 1,
        },
        {
          applicationId: "pc-gjjtqjlcxlxxka",
          text: "公积金提取记录查询",
          userType: 1,
        },
        {
          applicationId: "pc-gjtqjdcxvnovp",
          text: "公积金提取进度查询",
          userType: 1,
        },
        {
          applicationId: "pc-gjjcjlcxudcjj",
          text: "公积金缴存记录查询",
          userType: 1,
        },
        {
          applicationId: "pc-gjjjcxxcxmxqdt",
          text: "公积金缴存信息查询",
          userType: 1,
        },
        {
          applicationId: "pc-grgxxwzmbldykfaom",
          text: "个人高校学位证明办理打印",
          userType: 1,
        },
        {
          applicationId: "pc-grgxxwzscxalffx",
          text: "高校学位证书查询",
          userType: 1,
        },
        {
          applicationId: "pc-hydjyydlhpo",
          text: "婚姻登记预约",
          userType: 1,
        },
        {
          applicationId: "pc-dqshydjxxhyiyccs",
          text: "大庆市婚姻登记信息核验",
          userType: 1,
        },
        {
          applicationId: "pc-bdcdjxxyzdylwv",
          text: "婚姻登记证明办理打印",
          userType: 1,
          print: true,
        },
        {
          applicationId: "pc-hygxzmhsgin",
          text: "婚姻关系证明",
          userType: 1,
        },
        {
          applicationId: "pc-grhygxzmbldyagfsx",
          print: true,
          text: "个人婚姻关系证明办理打印",
          userType: 1,
        },
        {
          applicationId: "pc-hhzmcxovyew",
          text: "火化证明查询",
          userType: 1,
        },
        {
          applicationId: "pc-hhzmcxovyew",
          text: "死亡医学证明信息查询",
          userType: 1,
        },
        {
          applicationId: "pc-gscfxxcxffikr",
          text: "公示处罚信息查询",
          userType: 2,
        },
        {
          applicationId: "pc-sgjbxxzmrsb",
          text: "事故基本信息",
          userType: 1,
        },
        {
          applicationId: "pc-qyfrggxypjjgdhnfu",
          text: "企业法人公共信用评价结果",
          userType: 2,
        },
        {
          applicationId: "pc-qyfrggxypjjgdyadkcq",
          text: "企业法人公共信用评价结果打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "pc-gqczbgdjxxtooau",
          text: "股权出质变更登记信息",
          userType: 2,
        },
        {
          applicationId: "pc-jzscqyxxvbjox",
          text: "建筑市场企业信息",
          userType: 2,
        },
        {
          applicationId: "pc-jzscryxxjnruc",
          text: "建筑市场人员信息",
          userType: 2,
        },
        {
          applicationId: "pc-jzscryxxjnruc",
          text: "建筑市场人员信息证明办理打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "zybbsydwcxqcdoz",
          text: "中央编办事业单位查询",
          userType: 2,
        },
        {
          applicationId: "pc-sydwxxcxggisw",
          text: "事业单位信息查询",
          userType: 2,
        },
        {
          applicationId: "pc-sydwxxcxggisw",
          text: "事业单位信息证明办理打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "pc-qytzrxxsggkh",
          text: "企业投资人信息",
          userType: 2,
        },
        {
          applicationId: "pc-qytzrzmbldyjgjhl",
          print: true,
          text: "企业投资人证明办理打印",
          userType: 2,
        },
        {
          applicationId: "pc-nbxxcxzapcd",
          text: "年报信息查询",
          userType: 2,
        },
        {
          applicationId: "pc-nbxxcxdyvtxev",
          print: true,
          text: "年报信息查询打印",
          userType: 2,
        },
        {
          applicationId: "pc-ycmlztxxacter",
          text: "异常名录主体信息",
          userType: 2,
        },
        {
          applicationId: "pc-jgsyylgrjbxxlvyaz",
          text: "机关事业养老个人基本信息",
          userType: 1,
        },
        {
          applicationId: "pc-dxxxcxuonov",
          text: "吊销信息查询",
          userType: 2,
        },
        {
          applicationId: "pc-jnryzyzgzsxxcxjhqiw",
          text: "技能人员职业资格证书信息查询",
          userType: 1,
        },
        {
          applicationId: "pc-qysldjxxkinql",
          text: "企业设立登记信息",
          userType: 2,
        },
        {
          applicationId: "pc-frhmdzmbldygddib",
          text: "法人黑名单证明办理打印",
          userType: 2,
          print: true,
        },
        {
          applicationId: "pc-sbjfxxqyrwzfh",
          text: "信用_社保缴费信息",
          userType: 2,
        },
        {
          applicationId: "pc-ssjj_qyjbxxpljxz",
          text: "省市监局_企业基本信息",
          userType: 2,
        },
      ],
      CY: {
        // 健康证
        36: "大庆市中西医结合医院",
        37: "杜蒙县人民医院",
        38: "红岗区人民医院",
        31: "林甸县医院",
        39: "大庆龙南医院乘风院区",
        40: "大庆市让胡路区人民医院",
        41: "大庆市中医医院",
        42: "元利博远健康体检中心",
        43: "锦程医院",
        44: "盛仁综合门诊部",
        45: "肇源县妇幼保健计划生育服务中心",
        46: "肇源县中医院",
        33: "肇源县总医院",
        34: "肇州县人民医院",
        22: "大庆龙南医院",
        47: "萨尔图区人民医院",
        48: "大庆市油田总院健康管理中心",
        49: "大庆市人民医院体检科",
        50: "大庆创伤医院",
        26: "大庆市第五医院",
        521: "大庆北大健康西城综合门诊部",
        522: "大庆铭德医院",
        523: "大庆北大健康综合门诊部",
        2521: "大庆市龙凤区人民医院",
        7521: "大庆市让胡路区关爱健康综合门诊部",
        8521: "万里云健康体检中心",
        8522: "大庆振培中医医院",
        9021: "大庆市让胡路区银亿济世中医院",
        6533: "大庆新村医院",
        9521: "大庆乘风中医院",
        10021: "康源中医医院",
        10521: "大庆市让胡路区厚泽健康体检中心",
        11023: "肇源县至诚医院",
        12021: "大庆百湖中医院",
        12521: "盛德医院",
        5021: "大庆友谊医院",
        6535: "林甸县中医院",
      },
      HGZDirect: {
        0: "A类",
        1: "B类",
        7: "食品卫生，公共卫生",
        3: "一般家政服务",
        4: "居家家政服务",
        5: "养老照护服务",
        6: "母婴照护服务",
      },
      tableVal: [],

      // 用户部分
      loginInfo: {},

      //弹窗部分
      showtaoast: false,
      ruleForm: {
        name: "",
        idcrad: "",
        inputcode: "",
        // 共享填写数据
        // 企业名称
        enterpriseName: "",
        // 联系人
        phonename: "",
        // 联系人手机号
        phone: "",
        phonenumber: "",
        // 服务类型
        ServiceType: "",
        // 说明
        desc: "",
        username: "",
        // 码上共享
        requirementTypeListseq: "",
        requirementStatusListseq: "",
        // 我向服务说句话
        wind: "",

        // 码上金融
        aralistSeq: "",
        enterpriseAddress: "",
        enterpriseCreate: "",
        optionSeq: "",
        money: "",
        collateral: "",
        banklistseq: "",
        // 新生儿
        birthCode: "",
        momName: "",
        momIdCode: "",
        // 个人高校学位证明办理打印
        certificateNumber: "",

        // 婚姻登记预约
        value1: "",
        sjd: "",
        // 婚姻关系证明
        nName: "",
        nIdcard: "",
        gName: "",
        gIdcard: "",
        //火化证明
        nameValue: "",
        idCardValue: "",

        // 事故
        value: "",
        //股权出质变更登记信息
        unitValue: "",
        paperCode: "",
        // 异常名录主体信息，
        marprId: "",
      },

      rules: {
        inputcode: [
          { validator: checkinputcode, trigger: "blur", required: true },
        ],
      },
      inputcode: "",
      tableValshow: false,
      imgData: "",
      isHaveHeaderInfo: false,
      HS_Infor: [],
      token: "",
      loading: false,
      type: "",
      // 码上共享
      requirementTypeList: [],
      requirementStatusList: [],
      // 我向服务说句话
      tableList: false,
      tableListadd: [],
      // 地区列表
      aralist: [],
      aralistSeq: "",
      banklist: [],
      banklistseq: "",
      options: [
        { loanType: 1, name: "首贷" },
        { loanType: 2, name: "续贷" },
      ],
      optionSeq: "",
      enterpriseCreate: "",
      newdata: "",
      type: true,
      timerNow: "",
      responseId: "",
      sjdoptions: [
        {
          val: 1,
          name: "上午",
        },
        {
          val: 2,
          name: "下午",
        },
      ],
    };
  },
  created() {
    this.timerNow = this.timeTurn(new Date().getTime());

    this.getshow();
    // this.getlist()
  },
  mounted() {
    this.verifyCode = new GVerify("auth_code");
  },
  methods: {
    getswitchTicket: async function () {
      var that = this;
      let datajson = {};
      let response = await switchTicket(datajson);
      console.log(response);
      if (
        Object.keys(response.data).length == 0 ||
        Object.keys(JSON.parse(response.data.resultDate).data).length == 0
      ) {
        that.$message({
          dangerouslyUseHTMLString: true,
          iconClass: "myicon",
          message:
            '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">请先登录！</div>',
        });
        setTimeout(function () {
          window.open(
            "https://www.zwfw.hlj.gov.cn/api-gateway/hljzwfw-jis-third-server/front/sso/appLogin?redirectUrl= " +
            'https://www.zwfw.hlj.gov.cn/jmopenpub/jmopen_files/webapp/html5/pc-swyxzmxxcxojvei/index.html'

          );
        }, 2000)
        // that.getuserInfo('66ee23eef7c848039616633da5ba06ae')
       
      } else {
        that.getuserInfo(JSON.parse(response.data.resultDate).data.ticket);
      }
    },
    // 5个查询
    //  三个查询
    goecked: async function (item) {
      var that = this;
      that.loading = true;
      let sign = null;
      let data = {
        listType: item,
        pageNum: 1,
        pageSize: 10000,
        enterpriseCode: that.loginInfo.credNum,
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "e8ef2143-721f-42bd-a280-58845d2ec2a3",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "e8ef2143-721f-42bd-a280-58845d2ec2a3",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo.data);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          let doDecrypt = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(doDecrypt);
          let res = JSON.parse(doDecrypt);
          console.log(res);
          if (res.code == 20000) {
            if (res.data.pageInfo.list == "") {
              that.tableList = true;
              that.tableListadd = [];
              setTimeout(function () {
                that.loading = false;
              }, 2000);
            } else {
              var resDataTemp = [];
              var resData = [];
              if (that.swiperList.text == "码上共享") {
                for (let item of res.data.pageInfo.list) {
                  resData.push({
                    需求类型: item.requireTypeName,
                    需求类别: item.requireName,
                    应用场景及应用内容: item.detail,
                    提交时间: item.createTime,
                  });
                }
              } else if (that.swiperList.text == "码上创业") {
                for (let item of res.data.pageInfo.list) {
                  resData.push({
                    企业名称: item.enterpriseName,
                    联系人: that.desensitizeChineseName(item.contacts),
                    联系人手机号: that.phoneNumber(item.phone),
                    服务类型: item.typeName,
                    说明: item.detail,
                  });
                }
              } else if (that.swiperList.text == "码上维权") {
                for (let item of res.data.pageInfo.list) {
                  resData.push({
                    企业名称: item.enterpriseName,
                    联系人: that.desensitizeChineseName(item.contacts),
                    联系人手机号: that.phoneNumber(item.phone),
                    维权内容: item.content,
                  });
                }
              } else if (that.swiperList.text == "码上融资") {
                for (let item of res.data.pageInfo.list) {
                  resData.push({
                    企业名称: item.enterpriseName,
                    联系人: that.desensitizeChineseName(item.contacts),
                    联系人手机号: that.phoneNumber(item.phone),
                    所属区县: item.countyName,
                    企业地址: item.enterpriseAddress,
                    企业成立时间: item.enterpriseCreate.slice(0, 10),
                    "首贷/继贷": item.loanType == 1 ? "首贷" : "继贷",
                    贷款额度: item.money,
                    抵押物: item.collateral,
                    目标银行: item.bankName,
                  });
                }
              }

              resData.forEach((items) => {
                let itemDataTemp = [];

                for (let key in items) {
                  if (key != "result") {
                    itemDataTemp.push({
                      title: key,
                      body: items[key],
                    });
                  }
                }
                resDataTemp.push(itemDataTemp);
                console.log(resDataTemp);
                that.tableList = true;
                setTimeout(function () {
                  that.loading = false;
                }, 2000);
                that.tableListadd = resDataTemp;
              });
            }
          } else {
            that.tableList = true;
            setTimeout(function () {
              that.loading = false;
            }, 2000);
            that.tableListadd = [];
          }
        }
      }
    },

    goeck: async function () {
      var that = this;
      that.loading = true;
      let sign = null;
      var data = {
        phone: that.loginInfo.mobile,
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "e5yuf23-721f-42bd-a5680-58845hkmc2a3",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "e5yuf23-721f-42bd-a5680-58845hkmc2a3",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo.data);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          let doDecrypt = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(doDecrypt);
          let res = JSON.parse(doDecrypt);
          console.log(res);
          if (res.code == 20000) {
            if (res.data.pageInfo.list == "") {
              that.tableList = true;
              that.tableListadd = [];
              setTimeout(function () {
                that.loading = false;
              }, 2000);
            } else {
              var resDataTemp = [];
              var resData = [];
              for (let item of res.data.pageInfo.list) {
                resData.push({
                  窗口号: item.winName,
                  姓名: that.desensitizeChineseName(item.userName),
                  内容: item.content,
                  提交时间: item.createTime,
                });
              }
              resData.forEach((items) => {
                let itemDataTemp = [];

                for (let key in items) {
                  if (key != "result") {
                    itemDataTemp.push({
                      title: key,
                      body: items[key],
                    });
                  }
                }
                resDataTemp.push(itemDataTemp);
                console.log(resDataTemp);
                that.tableList = true;
                that.tableListadd = resDataTemp;
                setTimeout(function () {
                  that.loading = false;
                }, 2000);
              });
            }
          } else {
            that.tableList = true;
            that.tableListadd = [];
            setTimeout(function () {
              that.loading = false;
            }, 2000);
          }
        }
      }
    },
    getshow: function () {
      console.log(appCollection.applicationName);
      var that = this;
      var param = {};
      param.name = appCollection.applicationName;
      if (param.name) {
        that.swiperList = that.swiperListOrg.find(
          (item) => item.text == param.name
        );
        console.log(that.swiperList);
        if (param.name == "码上共享") {
          that.getQsShareType();
        } else if (param.name == "码上创业") {
          that.getJyType();
        } else if (param.name == "码上融资") {
          that.getarealist();
          that.getabanklist();
        }
        document.querySelector('title').innerText =appCollection.applicationName ;
        that.getswitchTicket();
        // that.getuserInfo("4195d1aa093945f9866b513c78264afd");
      } else {
        that.swiperList = {};
      }
    },
    getuserInfo: async function (ticket) {
      var that = this;
      let sign = null;
      let jmContent = commonUtils.sm2doEncrypt(ticket);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b56",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b56",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);

      if (responseInfo.success && responseInfo.code != 401) {
        let realData = JSON.parse(responseInfo.data);
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        let res = JSON.parse(doDecrypt);
        console.log(res);
        if (res.status == "200") {
          if (res.data.usertype == 2 && that.swiperList.userType == 1) {
            that.$message({
              dangerouslyUseHTMLString: true,
              iconClass: "myicon",
              message:
                '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">本服务仅支持个人账户使用!</div>',
            });
          } else if (res.data.usertype == 1 && that.swiperList.userType == 2) {
            that.$message({
              dangerouslyUseHTMLString: true,
              iconClass: "myicon",
              message:
                '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">本服务仅支持法人账户使用!</div>',
            });
          } else {
            if (res.data.uType == 1) {
              that.loginInfo = res.data;
              console.log(that.loginInfo);
              that.ruleForm.name = that.desensitizeChineseName(
                res.data.username
              );
              that.ruleForm.idcrad = that.desensitizeIDNumber(
                res.data.paperCode
              );
              that.ruleForm.username = that.desensitizeChineseName(
                res.data.username
              );
              that.ruleForm.phone = that.phoneNumber(res.data.mobile);
              that.token = res.token;
            } else if (res.data.uType == 2) {
              that.loginInfo = res.data;
              console.log(that.loginInfo);
              that.ruleForm.name = res.data.name;
              that.ruleForm.idcrad = res.data.credNum;
              that.ruleForm.username = that.desensitizeChineseName(
                res.data.username
              );
              that.ruleForm.phone = that.phoneNumber(res.data.mobile);
              that.ruleForm.paperCode = that.desensitizeIDNumber(
                res.data.corporationId
              );
              that.token = res.token;
            }
          }
        } else {
          that.$message({
            dangerouslyUseHTMLString: true,
            iconClass: "myicon",
            message:
              '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">获取用户信息失败!</div>',
          });
        }
      } else {
        that.$message({
          dangerouslyUseHTMLString: true,
          iconClass: "myicon",
          message:
            '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">获取用户信息失败!</div>',
        });
      }
    },
    goQuery: async function (formName) {
      var that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // let currentuserType = appCollection.applicationList.find(
          //   item => item.text == appCollection.applicationName
          // ).userType;
          // if (that.loginInfo.usertype == "1" && currentuserType == "2") {
          //   that.identity = '法人'
          //   that.showtaoast = true
          //   setTimeout(function () {
          //     that.showtaoast = false
          //   }, 3000)
          // } else if (that.loginInfo.usertype == "2" && currentuserType == "1") {

          // } else {

          if (that.swiperList.text == "大庆市从业人员健康检查合格证明") {
            that.goType = 0;
            console.log("健康证查询");
            that.tableValshow = true;
            that.loading = true;
            that.getHeadinfo();
          } else {
            that.goType = "1";
            that.text = that.swiperList.text;
          }
          if (that.goType == "1") {
            if (
              that.text == "大庆市护照查询" ||
              that.text == "大庆市驾驶证证照" ||
              that.text == "大庆市居住证查询" ||
              that.text == "大庆市身份证查询" ||
              that.text == "大庆市户口本查询" ||
              that.text == "大庆市护照打印" ||
              that.text == "大庆市驾驶证打印" ||
              that.text == "大庆市居住证打印" ||
              that.text == "大庆市身份证打印" ||
              that.text == "大庆市户口本打印"
            ) {
              that.tableValshow = true;
              that.loading = true;
              that.getimg();
            } else {
              if (
                that.text == "大庆市公积金查询" ||
                that.text == "公积金缴存证明打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  大庆市公积金查询: "getAccuFund",
                  公积金缴存证明打印: "getAccuFund",
                };
                if (
                  _item == "大庆市公积金查询" ||
                  _item == "公积金缴存证明打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "大庆市燃气经营许可证" ||
                that.text == "大庆市燃气经营许可证打印" ||
                that.text == "大庆市事业单位法人证书" ||
                that.text == "大庆市事业单位法人证书打印" ||
                that.text == "大庆市快递业务经营许可证" ||
                that.text == "大庆市快递业务经营许可证打印"
              ) {
                that.tableValshow = true;
                that.loading = true;
                that.getlegalperson();
              } else if (that.text == "码上共享") {
                that.submitShare();
              } else if (that.text == "码上维权") {
                that.submitProtection();
              } else if (that.text == "码上创业") {
                that.submitEmployment();
              } else if (that.text == "我向政务服务说句话") {
                that.submitservicWword();
              } else if (that.text == "码上融资") {
                that.submitfinancing();
              } else if (
                that.text == "法人黑名单查询" ||
                that.text == "法人黑名单证明办理打印" ||
                that.text == "企业黑名单信息" ||
                that.text == "企业黑名单证明办理打印"
              ) {
                var _item = that.text;
                let obj = {
                  法人黑名单查询: "getEnterpriseBlacklistInfo",
                  法人黑名单证明办理打印: "getEnterpriseBlacklistInfo",
                  企业黑名单信息: "getEnterpriseBlacklistInfo",
                  企业黑名单证明办理打印: "getEnterpriseBlacklistInfo",
                };
                if (
                  _item == "法人黑名单查询" ||
                  _item == "法人黑名单证明办理打印" ||
                  _item == "企业黑名单信息" ||
                  _item == "企业黑名单证明办理打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "参保凭证查询" ||
                that.text == "社保缴费证明打印" ||
                that.text == "个人社保参保信息证明办理打印" ||
                that.text == "大庆市个人社保参保信息"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  参保凭证查询: "apiConvert/getPersonalInsuranceInfo",
                  社保缴费证明打印: "apiConvert/getPersonalInsuranceInfo",
                  个人社保参保信息证明办理打印:
                    "apiConvert/getPersonalInsuranceInfo",
                  大庆市个人社保参保信息: "apiConvert/getPersonalInsuranceInfo",
                };
                if (
                  _item == "参保凭证查询" ||
                  _item == "社保缴费证明打印" ||
                  _item == "个人社保参保信息证明办理打印" ||
                  _item == "大庆市个人社保参保信息"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "个人失业登记信息查询") {
                var url = "";
                var _item = that.text;
                let obj = {
                  个人失业登记信息查询: "apiConvert/getPersonalInsuranceInfo",
                };
                if (_item == "个人失业登记信息查询") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "新生儿出生证明登记" ||
                that.text == "国家出生医学证明办理查询" ||
                that.text == "国家出生医学证明办理打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  新生儿出生证明登记: "getObtainBirthCertificate",
                  国家出生医学证明办理查询: "getObtainBirthCertificate",
                  国家出生医学证明办理打印: "getObtainBirthCertificate",
                };
                if (
                  _item == "新生儿出生证明登记" ||
                  _item == "国家出生医学证明办理查询" ||
                  _item == "国家出生医学证明办理打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "不动产登记信息查询" ||
                that.text == "不动产产权验真" ||
                that.text == "电子营业执照信息查询" ||
                that.text == "电子营业执照信息打印"
              ) {
                that.getrealestate();
              } else if (
                that.text == "公积金贷款进度查询" ||
                that.text == "公积金还贷记录查询" ||
                that.text == "公积金提取记录查询" ||
                that.text == "公积金提取进度查询" ||
                that.text == "公积金缴存记录查询" ||
                that.text == "公积金缴存信息查询"
              ) {
                that.getuserAccumulationfund();
              } else if (
                that.text == "个人高校学位证明办理打印" ||
                that.text == "高校学位证书查询"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  高校学位证书查询: "getAcademicDegreeInfo",
                  个人高校学位证明办理打印: "getAcademicDegreeInfo",
                };
                console.log(_item);
                if (
                  _item == "高校学位证书查询" ||
                  _item == "个人高校学位证明办理打印"
                ) {
                  console.log(11111111);
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "婚姻登记预约") {
                that.getmarr();
              } else if (
                that.text == "大庆市婚姻登记信息核验" ||
                that.text == "婚姻登记证明办理打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  大庆市婚姻登记信息核验: "marriageMessageCheck",
                  婚姻登记证明办理打印: "marriageMessageCheck",
                };
                if (
                  _item == "大庆市婚姻登记信息核验" ||
                  _item == "婚姻登记证明办理打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "婚姻关系证明" ||
                that.text == "个人婚姻关系证明办理打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  婚姻关系证明: "bothSidesMarriageMessageCheck",
                  个人婚姻关系证明办理打印: "bothSidesMarriageMessageCheck",
                };
                if (
                  _item == "婚姻关系证明" ||
                  _item == "个人婚姻关系证明办理打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "火化证明查询" ||
                that.text == "死亡医学证明信息查询"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  火化证明查询: "getCremationMessage",
                  死亡医学证明信息查询: "getDeathCertificate",
                };
                if (
                  _item == "火化证明查询" ||
                  _item == "死亡医学证明信息查询"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "公示处罚信息查询") {
                var url = "";
                var _item = that.text;
                let obj = {
                  公示处罚信息查询: "getPublicPunishmentInfo",
                };
                if (_item == "公示处罚信息查询") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "事故基本信息") {
                var url = "";
                var _item = that.text;
                let obj = {
                  事故基本信息: "getBasicAccidentInfo",
                };
                if (_item == "事故基本信息") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "企业法人公共信用评价结果" ||
                that.text == "企业法人公共信用评价结果打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  企业法人公共信用评价结果: "getCorporateCreditEvaluationInfo",
                  企业法人公共信用评价结果打印:
                    "getCorporateCreditEvaluationInfo",
                };
                if (
                  _item == "企业法人公共信用评价结果" ||
                  _item == "企业法人公共信用评价结果打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "股权出质变更登记信息") {
                var url = "";
                var _item = that.text;
                let obj = {
                  股权出质变更登记信息: "getEquityPledgeChangeInfo",
                };
                if (_item == "股权出质变更登记信息") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "建筑市场企业信息") {
                var url = "";
                var _item = that.text;
                let obj = {
                  建筑市场企业信息: "getArchitectureEnterpriseInfo",
                };
                if (_item == "建筑市场企业信息") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "建筑市场人员信息" ||
                that.text == "建筑市场人员信息证明办理打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  建筑市场人员信息: "getArchitecturePersonInfo",
                  建筑市场人员信息证明办理打印: "getArchitecturePersonInfo",
                };
                if (
                  _item == "建筑市场人员信息" ||
                  _item == "建筑市场人员信息证明办理打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "事业单位信息查询" ||
                that.text == "事业单位信息证明办理打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  事业单位信息查询: "getGovernmentAffiliatedInstitutions",
                  事业单位信息证明办理打印:
                    "getGovernmentAffiliatedInstitutions",
                };
                if (
                  _item == "事业单位信息查询" ||
                  _item == "事业单位信息证明办理打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "中央编办事业单位查询") {
                var url = "";
                var _item = that.text;
                let obj = {
                  中央编办事业单位查询: "apiConvert/getInstitutionMessageCheck",
                };
                if (_item == "中央编办事业单位查询") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "企业投资人信息" ||
                that.text == "企业投资人证明办理打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  企业投资人信息: "getInvestorsInfo",
                  企业投资人证明办理打印: "getInvestorsInfo",
                };
                if (
                  _item == "企业投资人信息" ||
                  _item == "企业投资人证明办理打印"
                ) {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (
                that.text == "年报信息查询" ||
                that.text == "年报信息查询打印"
              ) {
                var url = "";
                var _item = that.text;
                let obj = {
                  年报信息查询: "getAnnualReportInfo",
                  年报信息查询打印: "getAnnualReportInfo",
                };
                if (_item == "年报信息查询" || _item == "年报信息查询打印") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "异常名录主体信息") {
                var url = "";
                var _item = that.text;
                let obj = {
                  异常名录主体信息: "getSubjectOfAnomalyInfo",
                };
                if (_item == "异常名录主体信息") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "机关事业养老个人基本信息") {
                var url = "";
                var _item = that.text;
                let obj = {
                  机关事业养老个人基本信息:
                    "apiConvert/getInstitutionalPensionInfo",
                };
                if (_item == "机关事业养老个人基本信息") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "吊销信息查询") {
                var url = "";
                var _item = that.text;
                let obj = {
                  吊销信息查询: "getRevokeInfo",
                };
                if (_item == "吊销信息查询") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "技能人员职业资格证书信息查询") {
                var url = "";
                var _item = that.text;
                let obj = {
                  技能人员职业资格证书信息查询:
                    "getSkilledPersonnelVocationalQualificationCertInfo",
                };
                if (_item == "技能人员职业资格证书信息查询") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "企业设立登记信息") {
                var url = "";
                var _item = that.text;
                let obj = {
                  企业设立登记信息:
                    "/sqlApi/simpleApi/646550c9f9a54af0b3e093b21240bb9c/e07295a3257d4c098070a8afa49d9379",
                };
                if (_item == "企业设立登记信息") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "信用_社保缴费信息") {
                var url = "";
                var _item = that.text;
                let obj = {
                  信用_社保缴费信息:
                    "/sqlApi/simpleApi/2f2d679642224466ae2b33e94af4f30d/88da63f3ad9c4fc39bf271c0481537ef",
                };
                if (_item == "信用_社保缴费信息") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              } else if (that.text == "省市监局_企业基本信息") {
                var url = "";
                var _item = that.text;
                let obj = {
                  省市监局_企业基本信息: "getEnterpriseBasicInfo",
                };
                if (_item == "省市监局_企业基本信息") {
                  that.tableValshow = true;
                  that.loading = true;
                  that.getData(
                    0,
                    obj[_item],
                    _item,
                    this.swiperList.applicationId
                  );
                }
              }
            }
          }

          // }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 姓名脱敏
    desensitizeChineseName(name) {
      if (!name) {
        return "";
      }
      if (name.length <= 1) {
        return name;
      }
      const firstChar = name.charAt(0);
      const starCount = name.length - 1;
      const stars = "*".repeat(starCount);
      return firstChar + stars;
    },
    // 身份证号脱敏
    desensitizeIDNumber(idNumber) {
      if (!idNumber) {
        return "";
      }
      if (idNumber.length < 4) {
        return idNumber;
      }
      const lastFourDigits = idNumber.slice(-4);
      const stars = "*".repeat(idNumber.length - 4);
      return stars + lastFourDigits;
    },
    // 手机号脱敏
    phoneNumber(phoneNumber) {
      // 手机号仅显示前三位及后四位数字，隐藏信息用*代替
      return phoneNumber.substr(0, 3) + "****" + phoneNumber.substring(7);
    },
    // 转时间戳
    timestampToTime(timestamp) {
      timestamp = timestamp ? timestamp : null;
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      // let h =
      //   (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      // let m =
      //   (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      //   ":";
      // let s =
      //   date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
    resetForm(formName) {
      this.tableValshow = false;
      this.tableVal = [];
      this.tableList = false;
      this.tableListadd = [];
      this.$refs[formName].resetFields();
      this.getswitchTicket();
      this.verifyCode = new GVerify("auth_code");
    },
    // 获取证照图片
    getimg: async function () {
      console.log(11111111);
      var that = this;
      let objTemp = {
        大庆市护照查询: {
          certificatetype: "2",
        },
        大庆市护照打印: {
          certificatetype: "2",
        },

        大庆市驾驶证证照: {
          certificatetype: "4",
        },
        大庆市驾驶证打印: {
          certificatetype: "4",
        },
        大庆市居住证查询: {
          certificatetype: "3",
        },
        大庆市居住证打印: {
          certificatetype: "3",
        },
        大庆市身份证查询: {
          certificatetype: "1",
        },
        大庆市身份证打印: {
          certificatetype: "1",
        },
        大庆市户口本查询: {
          certificatetype: "5",
        },
        大庆市户口本打印: {
          certificatetype: "5",
        },
      };
      var datainfo = {
        url_val: "api/getPoliceElectronicCert",
        name_val: that.loginInfo.name,
        idCard_val: that.loginInfo.paperCode,
        certificateType_val: objTemp[that.text].certificatetype,
        taskCode_val: "11111112222",
        itemCode_val: "11230601001773099R323209900800808",
        itemName_val: "影印本与原本相符公证",
      };
      console.log(datainfo);
      let sign = null;
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(datainfo));
      let jmToken = commonUtils.sm2doEncrypt(that.token);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        console.log(1111111);
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (responseInfo.success && responseInfo.code != 401) {
        console.log(responseInfo);
        if (!responseInfo.data) {
          that.tableValshow = true;
          that.tableVal = [];
          setTimeout(function () {
            that.loading = false;
          }, 2000);
        } else {
          let realData = JSON.parse(responseInfo.data);
          // 解密
          let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
          let res = JSON.parse(doDecrypt);
          console.log(res);
          if (res.status == "200") {
            var data = res.data;
            if (!data) {
              that.tableValshow = true;
              that.tableVal = [];
              setTimeout(function () {
                that.loading = false;
              }, 2000);
            } else {
              let sign = null;
              let jmContent = commonUtils.sm2doEncrypt(
                JSON.stringify({ UpFile: data })
              );
              let datajson = {
                app_id: that.swiperList.applicationId,
                interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b79",
                version: "1.0",
                header: JSON.stringify({}),
                biz_content: JSON.stringify({
                  param: jmContent,
                }),
                charset: "UTF-8",
                timestamp: "1698892210245",
                origin: 1,
              };
              let response = await createsign(datajson);
              if (response.success) {
                console.log(1111111);
                sign = response.data.sign;
              }
              let datajsonED = {
                app_id: that.swiperList.applicationId,
                interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b79",
                version: "1.0",
                header: JSON.stringify({}),
                biz_content: JSON.stringify({
                  param: jmContent,
                }),
                charset: "UTF-8",
                timestamp: "1698892210245",
                origin: 1,
                sign: sign,
              };
              let responseInfo = await query(datajsonED);
              let realData = JSON.parse(responseInfo.data);
              if (realData.data.length > 500) {
                that.imgData = realData.data;
                that.type = 1;
                that.tableValshow = true;
                setTimeout(function () {
                  that.loading = false;
                }, 2000);
                console.log(that.imgData);
              } else {
                that.tableValshow = true;
                that.tableVal = [];
                setTimeout(function () {
                  that.loading = false;
                }, 2000);
              }
            }
          } else {
            that.tableValshow = true;
            that.tableVal = [];
            setTimeout(function () {
              that.loading = false;
            }, 2000);
          }
        }
      } else {
        that.tableValshow = true;
        that.tableVal = [];
        setTimeout(function () {
          that.loading = false;
        }, 2000);
      }
    },
    // 获取健康证
    // getHeadth: async function () {
    //   var that =this
    //   let sign = null
    //   let jmToken = commonUtils.sm2doEncrypt(that.token);
    //   let datajson = {
    //     app_id: 'pcdcxcstipsp',
    //     interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b78",
    //     version: "1.0",
    //     header: JSON.stringify({
    //       access_token: jmToken
    //     }),
    //     biz_content: JSON.stringify({

    //     }),
    //     charset: "UTF-8",
    //     timestamp: "1698905834339",
    //     origin: 1
    //   }
    //   let response = await createsign(datajson);
    //   if (response.success) {
    //     console.log(1111111)
    //     sign = response.data.sign;
    //   }
    //   let datajsonED = {
    //     app_id: 'pcdcxcstipsp',
    //     interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b78",
    //     version: "1.0",
    //     header: JSON.stringify({
    //       access_token: jmToken
    //     }),
    //     biz_content: JSON.stringify({

    //     }),
    //     charset: "UTF-8",
    //     timestamp: "1698905834339",
    //     origin: 1,
    //     sign: sign
    //   }
    //   let responseInfo = await query(datajsonED)
    //   if (responseInfo.success && responseInfo.code != 401) {
    //     let realData = JSON.parse(responseInfo.data);
    //     let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
    //     let res = JSON.parse(doDecrypt);
    //     console.log(res)
    //     if (res.status == "200") {
    //       var data = res.data;
    //       if (!data) {
    //         that.isHaveHeaderInfo = false;
    //       } else {
    //         that.isHaveHeaderInfo = true;
    //       }
    //     }
    //   }
    // },
    getHeadinfo: async function () {
      var that = this;
      let sign = null;
      let jmContent = commonUtils.sm2doEncrypt(
        JSON.stringify({ access_token: that.token })
      );
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b11",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b11",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (responseInfo.success && responseInfo.code != 401) {
        let realData = JSON.parse(responseInfo.data);

        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);

        let res = JSON.parse(doDecrypt);

        if (res.code == 20000) {
          var data = res.data;
          if (!data) {
            that.tableValshow = true;
            that.tableVal = [];
            setTimeout(function () {
              that.loading = false;
            }, 2000);
          } else {
            console.log(data);
            let resData = [];
            let resDataTemp = [];
            resData.push({
              从业类型: that.HGZDirect[data.cylx],
              检测结果: data.jcjg ? data.jcjg : "暂无",
              发证日期: data.fzrq ? data.fzrq : "暂无",
              有效期: data.yxq ? data.yxq : "暂无",
              健康检查单位: that.CY[data.jkjcdw]
                ? that.CY[data.jkjcdw]
                : "暂无",
            });

            resData.forEach((items) => {
              let itemDataTemp = [];

              for (let key in items) {
                if (key != "result") {
                  itemDataTemp.push({
                    title: key,
                    body: items[key],
                  });
                }
              }
              resDataTemp.push(itemDataTemp);
            });
            that.tableVal = resDataTemp;
            that.tableValshow = true;
            setTimeout(function () {
              that.loading = false;
            }, 2000);
          }
        }
      } else {
        that.tableValshow = true;
        setTimeout(function () {
          that.loading = false;
        }, 2000);
        that.tableVal = [];
      }
    },
    // 下载
    downloadIamge() {
      console.log(this.text);
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = appCollection.applicationName.slice(0, -2); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = this.imgData;
    },

    // 获取公积金
    async getData(_code, url, name, appId, spacel) {
      var that = this;
      let dataTempData = {
        name_val: "name",
        idCard_val: "idCard",
        url_val: "api/" + url,
        hide_val: _code,
        is_alipy: "1",
        is_yjs: "1",
      };
      if (url == "getObtainBirthCertificate") {
        dataTempData.birthCode_val = that.ruleForm.birthCode;
        dataTempData.momName_val = that.ruleForm.momName;
        dataTempData.momIdCode_val = that.ruleForm.momIdCode;
      } else if (url == "getAcademicDegreeInfo") {
        dataTempData.certNo_val = that.ruleForm.certificateNumber;
      } else if (url == "bothSidesMarriageMessageCheck") {
        dataTempData.name1_val = that.ruleForm.nName;
        dataTempData.name2_val = that.ruleForm.gName;
        dataTempData.idCard1_val = that.ruleForm.nIdcard;
        dataTempData.idCard2_val = that.ruleForm.gIdcard;
      } else if (url == "getCremationMessage" || url == "getDeathCertificate") {
        dataTempData.name_val = that.ruleForm.nameValue;
        dataTempData.idCard_val = that.ruleForm.idCardValue;
      } else if (url == "getBasicAccidentInfo") {
        dataTempData.year_val = that.ruleForm.value.substring(0, 4);
        dataTempData.month_val = that.ruleForm.value.substring(5, 7);
      } else if (url == "getCorporateCreditEvaluationInfo") {
        dataTempData.entName_val = "name";
        dataTempData.uniscid_val = "creditCode";
      } else if (url == "getEquityPledgeChangeInfo") {
        dataTempData.accOrgId_val = that.ruleForm.unitValue;
      } else if (url == "getArchitectureEnterpriseInfo") {
        dataTempData.year_val = that.ruleForm.value.substring(0, 4);
        dataTempData.month_val = that.ruleForm.value.substring(5, 7);
        dataTempData.uniscId_val = "creditCode";
      } else if (url == "getArchitecturePersonInfo") {
        dataTempData.year_val = that.ruleForm.value.substring(0, 4);
        dataTempData.month_val = that.ruleForm.value.substring(5, 7);
      } else if (url == "apiConvert/getInstitutionMessageCheck") {
        dataTempData.uniscid_val = "creditCode";
        delete dataTempData.idCard_val;
        delete dataTempData.name_val;
      } else if (url == "getGovernmentAffiliatedInstitutions") {
        dataTempData.code_val = "creditCode";
      } else if (url == "getInvestorsInfo") {
        dataTempData.cerNo_val = "idCard";
      } else if (url == "getAnnualReportInfo") {
        dataTempData.entName_val = "name";
        dataTempData.regNo_val = "creditCode";
      } else if (url == "getSubjectOfAnomalyInfo") {
        dataTempData.marprId_val = that.ruleForm.marprId;
      } else if (
        url == "getEnterpriseBlacklistInfo" ||
        url == "getRevokeInfo"
      ) {
        dataTempData.entName_val = "哈尔滨月亮连锁有限公司沿江分公司";
        dataTempData.regNo_val = "230100100013211";
      } else if (url == "getSkilledPersonnelVocationalQualificationCertInfo") {
        dataTempData.certNo_val = "idCard";
        dataTempData.name_val = "name";
      } else if (url == "getPublicPunishmentInfo") {
        dataTempData.entName_val = "name";
        dataTempData.regNo_val = "creditCode";
      } else if (
        url ==
        "/sqlApi/simpleApi/646550c9f9a54af0b3e093b21240bb9c/e07295a3257d4c098070a8afa49d9379"
      ) {
        dataTempData.url_val = url;
        dataTempData.uniscid_val = "creditCode";
        dataTempData.entename_val = "name";
      } else if (
        url ==
        "/sqlApi/simpleApi/2f2d679642224466ae2b33e94af4f30d/88da63f3ad9c4fc39bf271c0481537ef"
      ) {
        dataTempData.url_val = url;
        dataTempData.uniscid_val = "creditCode";
        dataTempData.name_val = "name";
      } else if (url == "getEnterpriseBasicInfo") {
        dataTempData.uniorreg_val = "creditCode";
      }

      console.log(dataTempData);
      let sign = null;
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(dataTempData));
      let jmToken = commonUtils.sm2doEncrypt(that.token);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (
        responseInfo.success &&
        responseInfo.code != 401 &&
        responseInfo.code != 0
      ) {
        let realData = JSON.parse(responseInfo.data);
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        let res = JSON.parse(doDecrypt);
        console.log(res);
        if (res.status == "200") {
          if (res.data != undefined || res.data != null) {
            console.log(111111111);
            var data = res.data;
          } else {
            console.log(11221111111);
            var data = res.dataList;
          }
          if (!data) {
            that.tableValshow = true;
            that.tableVal = [];
            setTimeout(function () {
              that.loading = false;
            }, 2000);
          } else {
            var resData = [];
            var resDataTemp = [];

            if (res.responseId) {
              this.responseId = res.responseId;
            }
            if (
              name == "参保凭证查询" ||
              name == "社保缴费证明打印" ||
              name == "个人失业登记信息查询" ||
              name == "个人社保参保信息证明办理打印" ||
              name == "大庆市个人社保参保信息"
            ) {
              resData = res.data;
            } else if (
              name == "企业法人公共信用评价结果" ||
              name == "企业法人公共信用评价结果打印"
            ) {
              for (let item of res.data) {
                resData.push({
                  受评主体名称: item.ENTNAME,
                  综合得分: item.SCORE,
                  评价等级: item.RATING,
                  批次: item.BATCH,
                  统一社会信用代码: item.UNISCID,
                });
              }
            } else if (name == "中央编办事业单位查询") {
              console.log("232321321321");
              for (let item of res.dataList) {
                resData.push({
                  机构名称: item.JGMC,
                  有效期至: item.YXQZ,
                  统一社会信用代码: item.UNIFYCODE,
                  机构地址: item.ADDRESS,
                  颁发日期: item.BFRQ,
                  机构性质: item.JGXZ,
                  负责人: item.FZR,
                });
              }
            } else if (
              name == "婚姻关系证明" ||
              name == "个人婚姻关系证明办理打印"
            ) {
              resData.push({
                男方姓名: res.data.name1,
                男方身份证号: res.data.idCard1,
                女方姓名: res.data.name2,
                女方身份证号: res.data.idCard2,
                婚姻状态: res.data.marriageStatus,
              });
            } else if (name == "机关事业养老个人基本信息") {
              resData = res.dataList;
            } else if (
              name == "股权出质变更登记信息" ||
              name == "事故基本信息" ||
              name == "火化证明查询" ||
              name == "建筑市场企业信息" ||
              name == "建筑市场人员信息" ||
              name == "建筑市场人员信息证明办理打印" ||
              name == "建筑市场项目信息" ||
              name == "事业单位信息查询" ||
              name == "事业单位信息证明办理打印" ||
              name == "企业投资人信息" ||
              name == "企业投资人证明办理打印" ||
              name == "年报信息查询" ||
              name == "年报信息证明办理打印" ||
              name == "异常名录主体信息" ||
              name == "法人黑名单查询" ||
              name == "企业黑名单证明办理打印" ||
              name == "小微企业名录信息查询（2019年之前数据）" ||
              name == "吊销信息查询" ||
              name == "信用_社保缴费信息" ||
              name == "企业设立登记信息" ||
              name == "技能人员职业资格证书信息查询" ||
              name == "公示处罚信息查询" ||
              name == "企业黑名单信息" ||
              name == "法人黑名单证明办理打印" ||
              name == "企业黑名单信息" ||
              name == "年报信息查询打印"
            ) {
              resData = res.data;
            } else {
              resData.push(res.data);
            }

            resData.forEach((items) => {
              let itemDataTemp = [];

              for (let key in items) {
                if (key != "result") {
                  itemDataTemp.push({
                    title: key,
                    body: items[key],
                  });
                }
              }
              resDataTemp.push(itemDataTemp);
            });
            console.log("最终值", resDataTemp);
            this.tableVal = resDataTemp;
            if (this.tableVal.length == 0 || this.tableVal[0].length == 0) {
              that.tableValshow = true;
              setTimeout(function () {
                that.loading = false;
              }, 2000);
              that.tableVal = [];
            } else {
              this.tableVal = resDataTemp;
              that.tableValshow = true;
              setTimeout(function () {
                that.loading = false;
              }, 2000);
            }
          }
        } else {
          that.tableValshow = true;
          setTimeout(function () {
            that.loading = false;
          }, 2000);
          that.tableVal = [];
        }
      } else {
        that.tableValshow = true;
        setTimeout(function () {
          that.loading = false;
        }, 2000);
        that.tableVal = [];
      }
    },
    // 公积金保存图片
    saveImg() {
      html2canvas(this.$refs.imgBox, {
        height: this.$refs.imgBox.scrollHeight,
        width: this.$refs.imgBox.scrollWidth,
      }).then((canvas) => {
        const link = document.createElement("a"); // 创建一个超链接对象实例
        link.download = appCollection.applicationName.slice(0, -2); // 设置要下载的图片的名称
        link.href = canvas.toDataURL(); // 将图片的URL设置到超链接的href中
        link.click(); // 触发超链接的点击事件
      });
    },
    // 大庆市燃气经营许可证大庆市燃气经营许可证打印大庆市事业单位法人证书大庆市事业单位法人证书打印大庆市快递业务经营许可证大庆市快递业务经营许可证打印
    async getlegalperson() {
      var that = this;
      var text = "";
      if (
        that.swiperList.text == "大庆市燃气经营许可证" ||
        that.swiperList.text == "大庆市燃气经营许可证打印"
      ) {
        text = "燃气经营许可证";
      } else if (
        that.swiperList.text == "大庆市事业单位法人证书" ||
        that.swiperList.text == "大庆市事业单位法人证书打印"
      ) {
        text = "事业单位法人证书";
      } else if (
        that.swiperList.text == "大庆市快递业务经营许可证" ||
        that.swiperList.text == "大庆市快递业务经营许可证打印"
      ) {
        text = "快递业务经营许可证";
      }

      let dataTempData = {
        url_val: "api/getCertificateFileByHolderBakNew",
        certificateType_val: text,
        certificateHolderCode_val: that.loginInfo.credNum,
        hide_val: "0",
        is_alipy: "1",
        is_yjs: "1",
      };
      let sign = null;
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(dataTempData));
      let jmToken = commonUtils.sm2doEncrypt(that.token);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
      };
      let response = await createsign(datajson);
      console.log(response);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (responseInfo.success && responseInfo.code != 401) {
        let realData = JSON.parse(responseInfo.data);
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        let res = JSON.parse(doDecrypt);
        console.log(res);
        if (res.status == "200" && res.data.list != undefined) {
          that.getpic(res.data.list[0].certificateID);
        } else {
          that.tableValshow = true;
          setTimeout(function () {
            that.loading = false;
          }, 2000);
          that.tableVal = [];
        }
      } else {
        that.tableValshow = true;
        setTimeout(function () {
          that.loading = false;
        }, 2000);
        that.tableVal = [];
      }
    },
    async getpic(id) {
      console.log(id);
      var that = this;
      let dataTempData = {
        url_val: "api/getCertificatePreview",
        certificateID_val: id,
        is_alipy: "1",
        is_yjs: "1",
        is_base64: "1",
      };
      console.log(dataTempData);

      let sign = null;
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(dataTempData));
      let jmToken = commonUtils.sm2doEncrypt(that.token);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
      };
      let response = await createsign(datajson);
      console.log(response);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (responseInfo.success && responseInfo.code != 401) {
        let realData = JSON.parse(responseInfo.data);
        console.log(realData);
        if (realData.status == "200") {
          (that.imgData = "data:image/png;base64" + "," + realData.data),
            (that.tableValshow = true);
          setTimeout(function () {
            that.loading = false;
          }, 2000);
          that.type = 2;
        } else {
          that.tableValshow = true;
          setTimeout(function () {
            that.loading = false;
          }, 2000);
          that.tableVal = [];
        }
        // let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        // let res = JSON.parse(doDecrypt);
        // console.log(res)
        // if (res.status == '200') {

        // } else {
        //   that.tableValshow = true
        //   that.loading = false
        //   that.tableVal = [];
        // }
      } else {
        that.tableValshow = true;
        setTimeout(function () {
          that.loading = false;
        }, 2000);
        that.tableVal = [];
      }
    },

    // 获取需求类型
    async getQsShareType() {
      let that = this;
      let sign = null;
      let data = {};
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "a74e4de53ce841edb2412539232635ac",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "a74e4de53ce841edb2412539232635ac",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.requirementTypeList = JSON.parse(realData.data).data;
            console.log(that.requirementTypeList);
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">获取需求类型出错</div></div>',
            });
          }
        }
      }
    },
    chagerequirementTypeList() {
      console.log(1111111111);
      this.getQRShareRequire(this.ruleForm.requirementTypeListseq);
    },
    // 获取共享类型
    async getQRShareRequire(seq) {
      let that = this;
      let sign = null;
      let data = {
        parent: seq,
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "313fdafd9a1247989ab9973c4eb7e761",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "313fdafd9a1247989ab9973c4eb7e761",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.requirementStatusList = JSON.parse(realData.data).data;
            console.log(that.requirementStatusList);
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">获取需求类别出错</div></div>',
            });
          }
        }
      }
    },
    // 提交码上共享
    async submitShare() {
      var that = this;
      let sign = null;
      var data = {
        requireType: that.ruleForm.requirementTypeListseq,
        require: that.ruleForm.requirementStatusListseq,
        detail: that.ruleForm.desc,
        enterpriseName: that.loginInfo.name,
        enterpriseCode: that.loginInfo.credNum,
        contacts: that.loginInfo.handlerName,
        phone: that.loginInfo.mobile,
        areaCode: "230600",
      };
      console.log(data);
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "00B9EAB44270709BE0630100007FD21F",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "00B9EAB44270709BE0630100007FD21F",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "success",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">提交成功</div></div>',
            });
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">保存失败</div></div>',
            });
          }
        }
      }
    },
    // 提交码上维权
    async submitProtection() {
      var that = this;
      let sign = null;
      var data = {
        content: that.ruleForm.desc,
        enterpriseName: that.loginInfo.name,
        enterpriseCode: that.loginInfo.credNum,
        contacts: that.loginInfo.handlerName,
        phone: that.loginInfo.mobile,
        areaCode: "230600",
      };
      console.log(data);
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "05DC546F3DC62851E0630100007F2428",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "05DC546F3DC62851E0630100007F2428",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "success",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">提交成功</div></div>',
            });
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">保存失败</div></div>',
            });
          }
        }
      }
    },
    // 获取服务类型
    async getJyType() {
      let that = this;
      let sign = null;
      let data = {
        level: "3",
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "92a74cd6168b49eab02f7c8881de183a",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "92a74cd6168b49eab02f7c8881de183a",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.requirementTypeList = JSON.parse(realData.data).data;
            console.log(that.requirementTypeList);
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">获取需求类型出错</div></div>',
            });
          }
        }
      }
    },

    // 提交码上创业
    async submitEmployment() {
      var that = this;
      let sign = null;
      var data = {
        type: that.ruleForm.requirementTypeListseq,
        detail: that.ruleForm.desc,
        enterpriseName: that.ruleForm.enterpriseName,
        contacts: that.ruleForm.phonename,
        enterpriseCode: that.loginInfo.credNum,
        phone: that.ruleForm.phonenumber,
        idCard: "232",
        areaCode: "230600",
      };
      console.log(data);
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "80841148ca16436aa31fd31db55b61ca",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "80841148ca16436aa31fd31db55b61ca",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "success",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">提交成功</div></div>',
            });
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">保存失败</div></div>',
            });
          }
        }
      }
    },
    // 获取码上融资

    // gourl
    gourl() {
      console.log(11111111111);
      window.open(
        "https://www.zwfw.hlj.gov.cn/api-gateway/jpaas-jact-web-server/front/mail-write.do?platformIid=779cfa340d3c4b1792664fbb1d0772f6&appname=" +
        appCollection.applicationName
      );
    },
    submitservicWword: async function () {
      var that = this;
      let sign = null;
      let data = {
        phone: this.loginInfo.mobile,
        content: this.ruleForm.desc,
        winName: this.ruleForm.wind,
        userName: this.loginInfo.username,
      };
      console.log(data);
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "e5yuf2143-721f-42bd-a280-58845frec2a3",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "e5yuf2143-721f-42bd-a280-58845frec2a3",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "success",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">提交成功</div></div>',
            });
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">保存失败</div></div>',
            });
          }
        }
      }
    },
    getarealist: async function () {
      let that = this;
      let sign = null;
      let data = {
        parentCode: "230600",
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "271b79f6-49b6-414d-8803-8bbbf2b87f89",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "271b79f6-49b6-414d-8803-8bbbf2b87f89",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);

      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );

          let realData = JSON.parse(arr);

          if (realData.code == 20000) {
            that.aralist = realData.data;
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">获取需求类别出错</div></div>',
            });
          }
        }
      }
    },
    getabanklist: async function () {
      let that = this;
      let sign = null;
      let data = {
        pageNum: "1",
        pageSize: "1000",
        isBank: "1",
        areaCode: "230600",
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "8414b7a6-26bb-4496-a287-407769ab28ec",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "8414b7a6-26bb-4496-a287-407769ab28ec",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.banklist = realData.data.pageInfo.list;
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">获取需求类别出错</div></div>',
            });
          }
        }
      }
    },
    submitfinancing: async function () {
      var that = this;
      that.date(that.ruleForm.enterpriseCreate);
      let sign = null;
      let data = {
        enterpriseName: that.loginInfo.name,
        enterpriseCode: that.loginInfo.credNum,
        contacts: that.loginInfo.username,
        phone: that.loginInfo.mobile,
        areaCode: "230600",
        money: that.ruleForm.money, //金额
        bank: that.ruleForm.banklistseq, //银行
        detail: "", //需求描述
        countyCode: that.ruleForm.aralistSeq,
        enterpriseAddress: that.ruleForm.enterpriseAddress, //企业地址
        enterpriseCreate: that.newdata, //企业成立时间
        loanType: that.ruleForm.optionSeq, //贷款类型1：首贷 2：续贷
        collateral: that.ruleForm.collateral, //是否有抵押物
      };
      console.log(data);
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "99d6f5c9-7912-4d1f-8fd8-b19ed76dcaca",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "99d6f5c9-7912-4d1f-8fd8-b19ed76dcaca",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "success",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">提交成功</div></div>',
            });
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              type: "warning",
              message:
                '<div style="display: flex;flex-direction:column"><div style="font-weight:bold;">消息</div><div style="font-size: 14px;font-weight:bold; margin-top: 8px;">保存失败</div></div>',
            });
          }
        }
      }
    },
    date: async function (date) {
      // 原始日期字符串
      // const originalDateStr = "Sat Aug 12 2023 00:00:00 GMT+0800 (中国标准时间)";

      // 创建日期对象
      // const originalDate = new Date(originalDateStr);
      const originalDate = new Date(date); //传入的日期

      // 获取年、月、日
      const year = originalDate.getFullYear();
      const month = originalDate.getMonth() + 1; // 月份从0开始，所以需要加1
      const day = originalDate.getDate();

      // 格式化为指定的日期字符串
      const formattedDateStr = `${year}-${month
        .toString()
        .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
      this.newdata = formattedDateStr + " " + "00:00:00";
      console.log(formattedDateStr); // 输出 "2023-08-11"
      // return formattedDateStr;
    },
    // 获取不动产
    async getrealestate() {
      var that = this;
      var idcard = "";
      var text = "";
      if (
        that.swiperList.text == "不动产登记信息查询" ||
        that.swiperList.text == "不动产产权验真"
      ) {
        text = "中华人民共和国不动产权证书";
        idcard = that.loginInfo.paperCode;
      } else if (
        that.swiperList.text == "电子营业执照信息查询" ||
        that.swiperList.text == "电子营业执照信息打印"
      ) {
        text = "营业执照";
        idcard = that.loginInfo.credNum;
      }

      let dataTempData = {
        url_val: "api/getCertificateFileByHolderBak",
        certificateType_val: text,
        certificateHolderCode_val: idcard,
        taskCode_val: "11111112222",
        itemCode_val: "11230601001773099R323209900800808",
        itemName_val: "影印本与原本相符公证",
      };
      console.log(dataTempData);
      let sign = null;
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(dataTempData));
      let jmToken = commonUtils.sm2doEncrypt(that.token);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
      };
      let response = await createsign(datajson);
      console.log(response);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "6474d6cb-763d-f5fb-12d2-f1244113fd68",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      console.log(responseInfo);
      if (responseInfo.success && responseInfo.code != 401) {
        let realData = JSON.parse(responseInfo.data);
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        let res = JSON.parse(doDecrypt);
        console.log(res);
        if (res.status == "200" && res.data.list != undefined) {
          that.getpic(res.data.list[0].certificateID);
        } else {
          that.tableValshow = true;
          setTimeout(function () {
            that.loading = false;
          }, 2000);
          that.tableVal = [];
        }
      } else {
        that.tableValshow = true;
        setTimeout(function () {
          that.loading = false;
        }, 2000);
        that.tableVal = [];
      }
    },

    // 获取公积金信息
    async getuserAccumulationfund() {
      var that = this;
      let type = "";
      let sign = null;
      if (that.text == "公积金贷款进度查询") {
        type = "0";
      } else if (that.text == "公积金还贷记录查询") {
        type = "1";
      } else if (that.text == "公积金提取记录查询") {
        type = "2";
      } else if (that.text == "公积金提取进度查询") {
        type = "3";
      } else if (that.text == "公积金缴存记录查询") {
        type = "4";
      } else if (that.text == "公积金缴存信息查询") {
        type = "5";
      }
      var data = {
        type: type,
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let jmToken = commonUtils.sm2doEncrypt(that.token);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-0001",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        console.log(1111111);
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-0001",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);

      if (
        responseInfo.success &&
        responseInfo.code != 401 &&
        responseInfo.code != 0
      ) {
        let realData = JSON.parse(responseInfo.data);
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        let res = JSON.parse(doDecrypt);
        console.log(res);
        if (res.status == "200") {
         let data = res.data
          if (!data) {
            that.tableValshow = true;
            that.tableVal = [];
            setTimeout(function () {
              that.loading = false;
            }, 2000);
          } else {
        
            var resDataTemp = [];
            data.forEach((items) => {
              let itemDataTemp = [];

              for (let key in items) {
                if (key != "result") {
                  itemDataTemp.push({
                    title: key,
                    body: items[key],
                  });
                }
              }
              resDataTemp.push(itemDataTemp);
            });
            console.log("最终值", resDataTemp);
            this.tableVal = resDataTemp;
            if (this.tableVal.length == 0 || this.tableVal[0].length == 0) {
              that.tableValshow = true;
              setTimeout(function () {
                that.loading = false;
              }, 2000);
              that.tableVal = [];
            } else {
              this.tableVal = resDataTemp;
              that.tableValshow = true;
              setTimeout(function () {
                that.loading = false;
              }, 2000);
            }
          }
        } else {
          that.tableValshow = true;
          setTimeout(function () {
            that.loading = false;
          }, 2000);
          that.tableVal = [];
        }
      } else {
        that.tableValshow = true;
        setTimeout(function () {
          that.loading = false;
        }, 2000);
        that.tableVal = [];
      }
    },

    // 提交婚姻预约
    async getmarr() {
      var that = this;
      var sign = null;
      if (that.ruleForm.sjd == 1) {
        var orderTimeStart = "08:30";
        var orderTimeEnd = "09:00";
        var timeInterval = "08:30-09:00";
      } else {
        var orderTimeStart = "13:30";
        var orderTimeEnd = "14:00";
        var timeInterval = "13:30-14:00";
      }
      var data = {
        itemSeq: "fb0404e4582443569a08a867bd908297",
        date: that.ruleForm.value1,
        orderTimeStart: orderTimeStart,
        orderTimeEnd: orderTimeEnd,
        timeInterval: timeInterval,
        idCard: that.ruleForm.idcrad,
        name: that.ruleForm.name,
        phone: that.ruleForm.phone,
        channel: 0,
        type: "2",
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "05DC546F3DC62851E0630185852527F2428",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "05DC546F3DC62851E0630185852527F2428",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          paramSm2: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);
      if (responseInfo.success && responseInfo.code != 401) {
        if (!responseInfo.data) {
          return;
        } else {
          var arr = commonUtils.sm2doDecrypt(
            JSON.parse(responseInfo.data).data
          );
          console.log(arr);
          let realData = JSON.parse(arr);
          if (realData.code == 20000) {
            that.$message({
              dangerouslyUseHTMLString: true,
              iconClass: "myicon",
              message:
                '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">预约成功!</div>',
            });
          } else {
            that.$message({
              dangerouslyUseHTMLString: true,
              iconClass: "myicon",
              message:
                '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">预约失败!</div>',
            });
          }
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.congtent {
  width: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
}

.congtentheader {
  width: 100%;
  height: 172px;
  background: url("../assets/background.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}

.congtentheadertext {
  color: rgba(255, 255, 255, 1);
  font-size: 40px;
  text-align: left;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
  margin-left: 355px;
}

.congtentmiddle {
  width: 1200px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: -42px;
  display: flex;
  justify-content: center;
  padding-top: 47px;
}

.congtentmiddled {
  width: 1200px;
  height: 446px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: -42px;
  display: flex;
  justify-content: center;
}

.congtentmiddle_top {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
}

.congtentmiddle_toptext {
  width: 64px;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  text-align: right;
  font-family: SourceHanSansSC-regular;
}

.congtentmiddle_toptextinput {
  width: 492px;
  height: 50px;
  line-height: 50px;
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  color: rgba(192, 196, 204, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 12px;
}

.congtentmiddle_middle {
  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0 auto;
  margin-top: 24px;
}

.congtentmiddle_bootm {
  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0 auto;
  margin-top: 24px;
}

.congtentmiddle_toptextinputmiddle {
  width: 340px;
  height: 49px;
  line-height: 49px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  margin-left: 12px;
}

.congtentmiddle_box {
  width: 120px;
  height: 49px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  margin-left: 30px;
}

/deep/.el-form-item__label {
  line-height: 50px !important;
}

/deep/.el-input__inner {
  height: 49px;
  line-height: 49px;
  padding: 0 12;
  border-radius: 0px;
}

/deep/.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 110%;
  left: 14px;
}

/*  */

.congtentfooter {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.congtentfooterleft {
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  background-color: rgba(67, 147, 245, 1);
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
}

.congtentfooterleft:hover {
  cursor: pointer;
}

.congtentfooterright {
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  background-color: white;
  text-align: center;
  border: 1px solid rgba(67, 147, 245, 1);
  margin-left: 35px;
  color: rgba(67, 147, 245, 1);
  font-size: 16px;
}

.congtentfooterright:hover {
  cursor: pointer;
}

.congtentfooterno {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  margin-top: 40px;
  cursor: pointer;
}

.congtentfooternoimg {
  width: 16px;
  height: 16px;
}

.congtentfooternotext {
  color: rgba(67, 147, 245, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 5px;
}

.congtentfooternotexttwo {
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

/* 弹窗内容 */
.showtaostMiddle {
  width: 380px;
  height: 83px;

  border-radius: 4px;
  background-color: #edf5ff;
  border: 1px solid rgba(67, 147, 245, 1);
  position: absolute;
  top: 25px;
  left: 40%;
  display: flex;
  flex-direction: column;
}

.showtaostMiddletop {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 24px;
  margin-top: 15px;
}

.showtaostMiddletoperror {
  width: 26px;
  height: 26px;
}

.showtaostMiddletoptext {
  color: rgba(16, 16, 16, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-medium;
  font-weight: bold;
  margin-left: 12px;
}

.showtaostMiddlebottom {
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 62px;
  margin-top: 8px;
}

.congtentresult {
  width: 1200px;
  /* height: 310px; */
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.contentresulttext {
  color: rgba(16, 16, 16, 1);
  font-size: 22px;
  text-align: left;
  font-family: SourceHanSansSC-medium;
  margin-left: 30px;
}

.congtentresultarr {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contentresulttextline {
  width: 1140px;
  height: NaNpx;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  margin-top: 16px;
}

.congtentresultimg {
  width: 200px;
  height: 138px;
  margin-top: 31px;
}

.congtentresultimgtext {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-top: 35px;
  margin-bottom: 45px;
}

.congtentHaveresult {
  width: 1150px;
  background-color: rgba(255, 255, 255, 1);

  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin-top: 10px;
  margin-left: 30px;
  margin-bottom: 20px;
}

.congtentHaveresulttop {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.congtentHaveresulttopleft {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #ebecec;
  margin-bottom: -1px;
  margin-left: -1px;
}

.congtentHaveresulttoplefttxt {
  width: 188px;
  height: 60px;
  display: flex;
  align-items: center;
  background-color: rgba(245, 246, 248, 1);
  text-align: left;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
}

.congtentHaveresulttopleftnumber {
  width: 342px;
  height: 60px;
  display: flex;
  align-items: center;
  /* line-height: 60px; */
  background-color: rgba(255, 255, 255, 1);
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
  display: flex;
  align-items: center;
  overflow: auto;
}

.congtentresultimage {
  margin: 0 auto;
}

.contentresulttextheader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.contentresulttextdown {
  width: 80px;
  height: 40px;
  line-height: 40px;
  background-color: rgba(241, 242, 244, 1);
  text-align: center;
  margin-right: 30px;
  cursor: pointer;
}

/* 公积金打印页面 */
/* // 生成页面部分 */
.mainCenterMains {
  width: 740px;
  overflow: auto;
  margin: 15px auto 0;
  background-color: white;
}

.MidSpaceTopTitles {
  width: 695px;
  margin: 10px auto;
}

.MidSpaceTopStyle {
  margin: 13px auto 0;
  width: calc(100% - 20px);
  border: 2px solid #ddd;
  border-top: none;
  border-left: none;
  border-right: none;
  height: 45px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
}

.MidSpaceTopPic {
  flex: 1;
  width: 100%;
  height: 28px;
  line-height: 35px;
  display: flex;
  justify-content: flex-start;
  font-size: 24px;
}

.MidSpaceTopPic span {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
}

/deep/.MidSpaceTopNum {
  font-size: 16px;
  font-weight: none;
  height: 28px;
  line-height: 28px;
}

.MidSpaceEr {
  margin-top: 15px;
  height: 60px;
  width: 100%;
}

.MidSpaceName img {
  width: 60px;
  height: 60px;
  border: 1px solid black;
  float: right;
  line-height: 40px;
}

.MidSpaceName {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
}

/deep/.MidSpaceTopNum {
  font-size: 16px;
  font-weight: none;
  height: 28px;
  line-height: 28px;
}

.MidSpaceEr {
  margin-top: 15px;
  height: 60px;
  width: 100%;
}

.MidSpaceName img {
  width: 60px;
  height: 60px;
  border: 1px solid black;
  float: right;
  line-height: 40px;
}

.MidSpaceName {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
}

.MidSpacePer1 {
  width: calc(100% - 20px);
  margin: 25px auto 0;
  height: 20px;
  font-size: 18px;
}

.MidSpacePerName1 {
  margin-left: 10px;
  font-weight: bold;
}

.MidSpacePerId1 {
  margin-left: 10px;
}

.MidSpacePerInfo1 {
  width: calc(100% - 20px);
  text-indent: 2em;
  margin: 15px auto 0;
  line-height: 40px;
  height: 20px;
  font-size: 18px;
}

.MidSpaceComName {
  font-weight: bold;
}

.MidSpacePerData {
  height: 30px;
  line-height: 20px;
  font-weight: bold;
}

.MidSpaceBottom1 {
  width: calc(100% - 140px);
  margin: 30px auto 0;
  height: 20px;

  text-align: left;
  font-size: 18px;
}

.MidSpaceBottomRight1 {
  width: 150px;
  position: relative;
  left: -10px;
  top: -65px;
  font-size: 16px;
  float: right;
  text-align: center;
  position: relative;
}

.namesssss {
  text-align: center;
  width: 150px;
  margin-top: -55px;
}

.MidSpaceBottomRightDate1 {
  width: 150px;
  text-align: center;
  margin: 8px auto 0;
}

.Cross {
  width: 25%;
  height: 1px;
  margin-left: 70px;
  border-top: solid black 1px;
}

.sTable {
  width: calc(100% - 20px);
  font-size: 20px;
  margin: 80px auto 0;
  display: flex;
  text-align: center;
  flex-wrap: wrap;
}

.congtentHaveresulttoplefted {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid black;
  margin-bottom: -1px;
  /* margin-left: -1px; */
}

.congtentHaveresulttoplefttxted {
  width: 188px;
  /* height: 60px; */
  display: flex;
  align-items: center;

  text-align: left;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;

  padding-top: 30px;
  padding-bottom: 30px;
}

.congtentHaveresulttopleftnumbered {
  width: 342px;

  display: flex;
  align-items: center;
  /* line-height: 60px; */
  padding-top: 30px;
  padding-bottom: 30px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
  display: flex;
  align-items: center;
  border-left: 1px solid black;
}

.wrap {
  height: calc(100vh - 100px);
  overflow: auto;
  background: #f5f5f5;
  padding-top: 24rpx;
}
</style>
<style  lang="scss">
.el-message {
  display: flex;
  width: 380px;
  height: 83px;
  line-height: 20px;
  border-radius: 4px;
  background-color: #edf5ff !important;
  text-align: center;
  border: 1px solid rgb(67, 147, 245) !important;
  align-items: flex-start !important;
}

.myicon {
  width: 26px;
  height: 26px;
  background-image: url("../assets/mess.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.el-message p {
  margin-top: 7px !important;
}
</style>
